import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BaseUrl: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  FloatPercentage: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  PositiveInteger: { input: any; output: any; }
  URL: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Action = {
  __typename?: 'Action';
  datasourceId?: Maybe<Scalars['ID']['output']>;
  type: ActionType;
};

export enum ActionType {
  DatasourceProcessed = 'datasourceProcessed',
  ItemsCreated = 'itemsCreated',
  ItemsDeleted = 'itemsDeleted',
  ItemsUpdated = 'itemsUpdated'
}

export type ActorInput = {
  id: Scalars['ID']['input'];
  role: ActorRole;
};

/** Input for actor information */
export enum ActorRole {
  Brand = 'BRAND',
  Choose = 'CHOOSE',
  System = 'SYSTEM'
}

export type AuthMutations = {
  __typename?: 'AuthMutations';
  createInviteCode: CreateInviteCodeReturn;
  joinDeal: MutationReturn;
  postRegister: MutationReturn;
};


export type AuthMutationsCreateInviteCodeArgs = {
  dealId: Scalars['ID']['input'];
};


export type AuthMutationsJoinDealArgs = {
  dealId: Scalars['String']['input'];
  inviteCode: Scalars['String']['input'];
};


export type AuthMutationsPostRegisterArgs = {
  config: PostRegisterConfig;
};

export type AuthQueries = {
  __typename?: 'AuthQueries';
  members: Array<Member>;
  viewer: Viewer;
};


export type AuthQueriesMembersArgs = {
  dealId: Scalars['ID']['input'];
};

export type Author = {
  __typename?: 'Author';
  actorRole: ActorRole;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum BrandRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

/** Brand tiering resolved from HubSpot (company-level property). */
export enum BrandTiering {
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3'
}

/** Not implemented yet */
export type CsvDataSource = {
  __typename?: 'CSVDataSource';
  author?: Maybe<Author>;
  createdAt: Scalars['DateTime']['output'];
  errors: Array<DataSourceError>;
  id: Scalars['ID']['output'];
  importSummary?: Maybe<ImportSummary>;
  instructions: DataSourceInstructions;
  /** The signed URL of the CSV file */
  signedUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: DataSourceStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Campaign = {
  __typename?: 'Campaign';
  /** The name of the campaign. Often the name of the brand. */
  name: Scalars['String']['output'];
  numberOfProducts: Scalars['Int']['output'];
  /** GMV of the campaign in cents */
  revenue?: Maybe<Scalars['Int']['output']>;
  saleId: Scalars['ID']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type CampaignItem = {
  __typename?: 'CampaignItem';
  chooseDiscount?: Maybe<Scalars['Float']['output']>;
  choosePrice?: Maybe<Scalars['Int']['output']>;
  dealItemId: Scalars['ID']['output'];
  listPrice?: Maybe<Scalars['Int']['output']>;
  stockQuantity?: Maybe<Scalars['Int']['output']>;
};

export type CategoryTree = {
  __typename?: 'CategoryTree';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  notReturnable: Scalars['Boolean']['output'];
  subCategories?: Maybe<Array<CategoryTree>>;
  tva?: Maybe<Scalars['Float']['output']>;
};

export type CountryLabel = {
  __typename?: 'CountryLabel';
  code: Scalars['String']['output'];
  en?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type CreateInviteCodeReturn = CreateInviteCodeSuccess | DomainException;

export type CreateInviteCodeSuccess = {
  __typename?: 'CreateInviteCodeSuccess';
  inviteCode: Scalars['String']['output'];
};

export enum CsvTemplate {
  Classic = 'CLASSIC',
  Coupon = 'COUPON',
  CouponCodes = 'COUPON_CODES'
}

export type DataSourceError = {
  __typename?: 'DataSourceError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type DataSourceInstructions = {
  __typename?: 'DataSourceInstructions';
  /** Null pour CREATE_ONLY ou lorsqu’aucune clé d’ancrage n’est définie. */
  anchorKey?: Maybe<DealItemAnchorKey>;
  /** Présent seulement en UPDATE_ONLY quand des deal items ont été ciblés. Null = pas de filtre par IDs. */
  dealItemIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Présent seulement en UPDATE_ONLY quand un filtre de champs a été appliqué. Null = pas de filtre (tous les champs). */
  fields?: Maybe<Array<DatasourceInstructionUpdateField>>;
  instructionMode: DatasourceInstructionMode;
  notify: Scalars['Boolean']['output'];
};

export enum DataSourceStatus {
  Created = 'created',
  Error = 'error',
  Imported = 'imported',
  Pending = 'pending',
  Processed = 'processed'
}

export enum DatasourceInstructionMode {
  /** Create new products and update all fields of existing products */
  CreateAndUpdate = 'CREATE_AND_UPDATE',
  /** Only create new products, skip existing products */
  CreateOnly = 'CREATE_ONLY',
  /** Only update all fields of existing products, skip new products */
  UpdateOnly = 'UPDATE_ONLY'
}

export enum DatasourceInstructionUpdateField {
  Description = 'description',
  DiscountedPrice = 'discountedPrice',
  Images = 'images',
  ListPrice = 'listPrice',
  Name = 'name',
  Options = 'options',
  ProductCategory = 'productCategory',
  SourceUrl = 'sourceUrl',
  StockQuantity = 'stockQuantity'
}

export type Deal = {
  __typename?: 'Deal';
  /** The currently active version of the deal */
  activeVersion: DealVersion;
  /** ID of the currently active version */
  activeVersionId: Scalars['ID']['output'];
  brandId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataSources: Array<DealDataSource>;
  /** Get all available deal items versions */
  dealItemsWithVersions: Array<DealItemWithVersions>;
  /**
   * Get the deal shipping policy
   * Note that il will be always null, if multiples deals are queried
   */
  dealShippingPolicy?: Maybe<DealShippingPolicy>;
  editionMode: ActorRole;
  /** Get all external catalog connections for the deal */
  externalCatalogConnections: Array<ExternalCatalogConnection>;
  googleAnalyzeFileUrl?: Maybe<Scalars['String']['output']>;
  googleDriveImagesUrl?: Maybe<Scalars['String']['output']>;
  hasCouponCodesFile: Scalars['Boolean']['output'];
  hubspotDealId: Scalars['ID']['output'];
  /** Hubspot deal information */
  hubspotInfos: HubspotInfos;
  id: Scalars['ID']['output'];
  /** Get the latest previous campaigns for the brand. */
  latestPreviousCampaigns: Array<Campaign>;
  /** @deprecated Use hubspotInfos.dealManager instead */
  manager: DealManager;
  pricingMode: PricingMode;
  /** Get all available deal selection exports */
  selectionExports: Array<DealSelectionExport>;
  setupNote?: Maybe<Scalars['String']['output']>;
  state: DealState;
  updatedAt: Scalars['DateTime']['output'];
};

export type DealDataSource = CsvDataSource | ExternalCatalogDataSource | PreviousCampaignDataSource | ShopifyCatalogDataSource | WebsiteDataSource;

export type DealItem = {
  __typename?: 'DealItem';
  bestSellerQuantitySold?: Maybe<Scalars['Int']['output']>;
  buyingPrice?: Maybe<Scalars['Int']['output']>;
  chooseDiscount?: Maybe<Scalars['Float']['output']>;
  choosePrice?: Maybe<Scalars['Int']['output']>;
  couponExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  couponHowToUse?: Maybe<Array<Scalars['String']['output']>>;
  couponTerms?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  eeePrice?: Maybe<Scalars['Int']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  hasDescription: Scalars['Boolean']['output'];
  hasVatMargin: Scalars['Boolean']['output'];
  /**
   * Identifiant de l'entrée d'historique courante de cet item.
   * Utilisé par le frontend pour détecter les conflits avant un undo (CTRL+Z).
   */
  historyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  isBestSeller?: Maybe<Scalars['Boolean']['output']>;
  isSelected: Scalars['Boolean']['output'];
  listPrice?: Maybe<Scalars['Int']['output']>;
  madeIn?: Maybe<Scalars['String']['output']>;
  marginPercentage?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<DealItemGenericProperty>>;
  position?: Maybe<Scalars['Int']['output']>;
  potentialSalesVolume?: Maybe<Scalars['Int']['output']>;
  productCategory?: Maybe<ProductCategoryType>;
  productGroupKey: Scalars['String']['output'];
  productType: ProductType;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  stockQuantity?: Maybe<Scalars['Int']['output']>;
  updatingFields: Array<Scalars['String']['output']>;
  /** Get all validation errors for the deal */
  validationErrors: Array<ValidationError>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export enum DealItemAnchorKey {
  Sku = 'SKU',
  Url = 'URL'
}

/**
 * Input for creating a deal item
 * Only fields that are provided will be created
 */
export type DealItemCreateInput = {
  buyingPrice?: InputMaybe<Scalars['Int']['input']>;
  chooseDiscount?: InputMaybe<Scalars['Float']['input']>;
  choosePrice?: InputMaybe<Scalars['Int']['input']>;
  couponExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  couponHowToUse?: InputMaybe<Array<Scalars['String']['input']>>;
  couponTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountedPrice?: InputMaybe<Scalars['Int']['input']>;
  eeePrice?: InputMaybe<Scalars['Int']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  hasVatMargin?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isBestSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  listPrice?: InputMaybe<Scalars['Int']['input']>;
  madeIn?: InputMaybe<Scalars['String']['input']>;
  marginPercentage?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<DealItemGenericPropertyInput>>;
  potentialSalesVolume?: InputMaybe<Scalars['Int']['input']>;
  productCategoryId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<ProductType>;
  shippingPrice?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  stockQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type DealItemGenericProperty = {
  __typename?: 'DealItemGenericProperty';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DealItemGenericPropertyInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DealItemSelectionInput = {
  dealItemId: Scalars['ID']['input'];
  isSelected: Scalars['Boolean']['input'];
};

export type DealItemUpdate = {
  __typename?: 'DealItemUpdate';
  changedFields: Array<Scalars['String']['output']>;
  currentHistoryId: Scalars['ID']['output'];
  id: Scalars['String']['output'];
  previousHistoryId: Scalars['ID']['output'];
};

/**
 * Input for updating a deal item
 * Only fields that are provided will be updated
 */
export type DealItemUpdateInput = {
  buyingPrice?: InputMaybe<Scalars['Int']['input']>;
  chooseDiscount?: InputMaybe<Scalars['Float']['input']>;
  choosePrice?: InputMaybe<Scalars['Int']['input']>;
  couponExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  couponHowToUse?: InputMaybe<Array<Scalars['String']['input']>>;
  couponTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountedPrice?: InputMaybe<Scalars['Int']['input']>;
  eeePrice?: InputMaybe<Scalars['Int']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  hasVatMargin?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isBestSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  listPrice?: InputMaybe<Scalars['Int']['input']>;
  madeIn?: InputMaybe<Scalars['String']['input']>;
  marginPercentage?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<DealItemGenericPropertyInput>>;
  potentialSalesVolume?: InputMaybe<Scalars['Int']['input']>;
  productCategoryId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<ProductType>;
  shippingPrice?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  stockQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type DealItemUpdated = {
  __typename?: 'DealItemUpdated';
  changedFields: Array<Scalars['String']['output']>;
  dealItemWithVersions: DealItemWithVersions;
};

export type DealItemWithVersions = {
  __typename?: 'DealItemWithVersions';
  activeVersion: DealItem;
  id: Scalars['ID']['output'];
  lastBrandVersion?: Maybe<DealItem>;
  lastChooseVersion?: Maybe<DealItem>;
};

export type DealItemsUpdated = {
  __typename?: 'DealItemsUpdated';
  fromAction: Action;
  items: Array<DealItemUpdated>;
};

export type DealKpisResult = {
  __typename?: 'DealKpisResult';
  currentDealKpis: OfferKpis;
  evolutionInsightsV2?: Maybe<OfferEvolutionInsightsV2>;
  previousCampaignKpis?: Maybe<OfferKpis>;
};

export type DealManager = {
  __typename?: 'DealManager';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  photoUrl: Scalars['String']['output'];
};

export type DealPresence = {
  __typename?: 'DealPresence';
  dealId: Scalars['ID']['output'];
  users: Array<PresenceUser>;
};

export type DealSelectionExport = {
  __typename?: 'DealSelectionExport';
  createdAt: Scalars['DateTime']['output'];
  dealId: Scalars['ID']['output'];
  /**
   * Indicates if a download is available without exposing the actual storage path.
   * Use the dealSelectionExportSignedUrl query to get a valid signed URL when needed.
   */
  downloadUrlAvailable: Scalars['Boolean']['output'];
  errors: Array<SelectionExportError>;
  id: Scalars['ID']['output'];
  /** Google Sheet URL when the export targets a Google Sheet (analyse export); null otherwise. */
  sheetUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DealShippingPolicy = {
  __typename?: 'DealShippingPolicy';
  basicFrPickupPointDeliveryPrice?: Maybe<Scalars['Int']['output']>;
  deliveryOfferedNumberOfDays?: Maybe<Scalars['Int']['output']>;
  freeShippingMinimumOrderAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pickupPointNetwork?: Maybe<PickupPointNetwork>;
};

export type DealShippingPolicyInput = {
  /**
   * If defined, gives the price of the pickup point delivery
   * If null, removes this rule from sale shipping policy
   */
  basicFrPickupPointDeliveryPrice?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of days after given sale startAt date to get free shipping
   * If null, removes this rule from sale shipping policy
   */
  deliveryOfferedNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If defined, gives the minimum amount to order to get free shipping
   * If null, removes this rule from sale shipping policy
   */
  freeShippingMinimumOrderAmount?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If defined, gives the network of the pickup point delivery
   * If null, removes this rule from sale shipping policy
   */
  pickupPointNetwork?: InputMaybe<PickupPointNetwork>;
};

export enum DealState {
  Available = 'available',
  Empty = 'empty',
  NegotiationClosed = 'negotiationClosed',
  ScrapingInProgress = 'scrapingInProgress',
  ValidatedByBoth = 'validatedByBoth',
  ValidatedByBrand = 'validatedByBrand',
  ValidatedByChoose = 'validatedByChoose'
}

export type DealVersion = {
  __typename?: 'DealVersion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Author>;
  dealId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isValidatedByBrand: Scalars['Boolean']['output'];
  isValidatedByChoose: Scalars['Boolean']['output'];
  items: Array<DealItem>;
  status: DealVersionStatus;
  updatedAt: Scalars['DateTime']['output'];
  versionNumber: Scalars['Int']['output'];
};

export enum DealVersionStatus {
  Editable = 'editable',
  Locked = 'locked'
}

export type DomainException = {
  __typename?: 'DomainException';
  code: Scalars['String']['output'];
};

export enum ExportTemplate {
  Emerch = 'EMERCH',
  Sale = 'SALE'
}

export type ExternalCatalogConnection = {
  __typename?: 'ExternalCatalogConnection';
  cms: ExternalCatalogConnectionCms;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  syncs: Array<ExternalCatalogConnectionSync>;
};

export enum ExternalCatalogConnectionCms {
  Shopify = 'Shopify'
}

export type ExternalCatalogConnectionSync = {
  __typename?: 'ExternalCatalogConnectionSync';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExternalCatalogConnectionSyncStatus {
  Done = 'Done',
  Error = 'Error',
  Pending = 'Pending'
}

export type ExternalCatalogDataSource = {
  __typename?: 'ExternalCatalogDataSource';
  author?: Maybe<Author>;
  createdAt: Scalars['DateTime']['output'];
  errors: Array<DataSourceError>;
  id: Scalars['ID']['output'];
  instructions: DataSourceInstructions;
  source: Scalars['String']['output'];
  status: DataSourceStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type HubspotDealManager = {
  __typename?: 'HubspotDealManager';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  photoUrl: Scalars['String']['output'];
};

export type HubspotInfos = {
  __typename?: 'HubspotInfos';
  /** Deal manager resolved live from HubSpot. Prefer over Deal.manager. */
  dealManager?: Maybe<HubspotDealManager>;
  dealName: Scalars['String']['output'];
  /**
   * Sale typology, sourced from HubSpot's `logistique` field. `null` when
   * HubSpot has no value or an unknown value for this deal.
   */
  operationType?: Maybe<OperationType>;
  startDate: Scalars['DateTime']['output'];
  store: StoreRegion;
  /** Brand tiering resolved live from HubSpot. Null when unknown or when the deal has no primary company. */
  tiering?: Maybe<BrandTiering>;
};

export type ImportSummary = {
  __typename?: 'ImportSummary';
  excludedItemsUpdatedIds: Array<Scalars['ID']['output']>;
  itemsCreatedIds: Array<Scalars['ID']['output']>;
  itemsSkippedIds: Array<Scalars['ID']['output']>;
  selectedItemsUpdatedIds: Array<Scalars['ID']['output']>;
};

/** Language (ISO 639-1) */
export enum LanguageIso6391 {
  /** English (US) */
  EnUs = 'en_US',
  /** French (France) */
  FrFr = 'fr_FR'
}

export type Member = {
  __typename?: 'Member';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  picture: Scalars['String']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Given a deal ID, add an external catalog to the deal */
  addCouponCodesCsvDataSourceToDeal: MutationReturn;
  /** Given a deal ID, add a data source to the deal */
  addCsvDataSourceToDeal: MutationReturn;
  /** Given a deal ID, add a previous campaign to the deal */
  addPreviousCampaignToDeal: MutationReturn;
  addShopifyDataSourceToDeal: MutationReturn;
  /**
   * Given a hubspot deal ID, add a data source to the deal
   * Creates a new deal if it doesn't exist.
   */
  addWebsiteDataSourceToDeal: MutationReturn;
  authMutations: AuthMutations;
  /** Close deal negotiation (CHOOSE only). Sets deal state to negotiationClosed. */
  closeDealNegotiation: MutationReturn;
  /**
   * Compute psychological choose prices for the given items
   * The actor is automatically determined from the authenticated user
   */
  computeChoosePrice: MutationUpdateDealItemsReturn;
  computeChoosePriceV2: MutationUpdateDealItemsReturn;
  /**
   * Given a hubspot deal ID, create a new deal
   * It will return the deal ID if the deal is created
   * Note that if the deal already exists, it will return the existing deal ID
   */
  createDeal: MutationReturn;
  createDealItem: MutationReturn;
  deleteDealItems: MutationReturn;
  /** Edit deal shipping policy */
  editDealShippingPolicy: MutationReturn;
  /**
   * Export a deal csv template, it will return a csv string
   * Default lang is fr_FR
   */
  exportDealCsvTemplate: MutationReturn;
  /**
   * Asynchronously export a deal for analysis into a Google Sheet (SALE template).
   * Default lang is fr_FR.
   */
  exportDealForAnalyse: MutationReturn;
  /** Default lang is fr_FR */
  exportDealSelection: MutationReturn;
  extractColorFromImages: MutationReturn;
  /** Mark a data source as imported */
  markDataSourceAsImported: MutationReturn;
  /**
   * Move product groups to a target position (gap-closing by productGroupKey).
   * productGroupKeys[0] goes to targetPosition, productGroupKeys[1] to targetPosition+1, etc.
   * The actor is automatically determined from the authenticated user.
   */
  moveProductsToPosition: MutationReturn;
  /** Release control of a deal (CHOOSE only). Switches edition mode from CHOOSE to BRAND. */
  releaseDealControl: MutationReturn;
  /** Reopen deal negotiation (CHOOSE only). Clears negotiationClosed persisted status. */
  reopenDealNegotiation: MutationReturn;
  /**
   * Restaure des items d'un deal à un état historique précédent (CTRL+Z).
   * Guard optimiste : si un item a été modifié depuis le dernier update, l'undo entier est rejeté.
   * Tout ou rien : si un seul item est en conflit, aucun item n'est restauré.
   */
  restoreDealItemsHistory: MutationReturn;
  /**
   * Restore a previous deal version as the active version.
   * If the current active version is not locked, it will be locked automatically.
   */
  restoreDealVersion: MutationReturn;
  syncImages: MutationReturn;
  /** Take control of a deal (CHOOSE only). Switches edition mode from BRAND to CHOOSE. */
  takeDealControl: MutationReturn;
  triggerCategorizeDealItems: MutationReturn;
  /** Update the Google Drive images URL for a deal. Pass null to clear. */
  updateDealGoogleDriveImagesUrl: MutationReturn;
  /**
   * Update deal items with partial data
   * Only updates the fields provided in the input
   * The actor is automatically determined from the authenticated user
   */
  updateDealItemsV2: MutationUpdateDealItemsReturn;
  /** Update the pricing mode for a deal */
  updateDealPricingMode: MutationReturn;
  /** Update the setup note for a deal */
  updateDealSetupNote: MutationReturn;
  /** Mark a deal as validated by brand */
  validateDealSelection: MutationReturn;
};


export type MutationAddCouponCodesCsvDataSourceToDealArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationAddCsvDataSourceToDealArgs = {
  anchorKey?: InputMaybe<DealItemAnchorKey>;
  dealId: Scalars['ID']['input'];
  eMerchCustomFieldsHeaders?: InputMaybe<Array<Scalars['String']['input']>>;
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
};


export type MutationAddPreviousCampaignToDealArgs = {
  dealId: Scalars['ID']['input'];
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
  saleId: Scalars['ID']['input'];
};


export type MutationAddShopifyDataSourceToDealArgs = {
  collections?: InputMaybe<Array<ShopifyCollectionInput>>;
  dealId: Scalars['ID']['input'];
  dealItemsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fields?: InputMaybe<Array<DatasourceInstructionUpdateField>>;
  gtins?: InputMaybe<Array<Scalars['String']['input']>>;
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<ShopifyProductStatus>>;
};


export type MutationAddWebsiteDataSourceToDealArgs = {
  dataSourceParams: WebsiteDataSourceParamsInput;
  hubspotDealId: Scalars['ID']['input'];
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
};


export type MutationCloseDealNegotiationArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationComputeChoosePriceArgs = {
  dealId: Scalars['ID']['input'];
  itemIds: Array<Scalars['ID']['input']>;
};


export type MutationComputeChoosePriceV2Args = {
  dealId: Scalars['ID']['input'];
  itemIds: Array<Scalars['ID']['input']>;
  strategy?: InputMaybe<PsychologicalPriceStrategy>;
};


export type MutationCreateDealArgs = {
  hubspotDealId: Scalars['ID']['input'];
};


export type MutationCreateDealItemArgs = {
  dealId: Scalars['ID']['input'];
  item: DealItemCreateInput;
};


export type MutationDeleteDealItemsArgs = {
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDealShippingPolicyArgs = {
  dealId: Scalars['ID']['input'];
  shippingPolicy: DealShippingPolicyInput;
};


export type MutationExportDealCsvTemplateArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageIso6391>;
  templateId?: InputMaybe<CsvTemplate>;
};


export type MutationExportDealForAnalyseArgs = {
  dealId: Scalars['ID']['input'];
  language?: InputMaybe<LanguageIso6391>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportDealSelectionArgs = {
  dealId: Scalars['ID']['input'];
  language?: InputMaybe<LanguageIso6391>;
  persistToDrive?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<ExportTemplate>;
};


export type MutationExtractColorFromImagesArgs = {
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']>;
};


export type MutationMarkDataSourceAsImportedArgs = {
  dataSourceId: Scalars['ID']['input'];
  dealId: Scalars['ID']['input'];
};


export type MutationMoveProductsToPositionArgs = {
  dealId: Scalars['ID']['input'];
  productGroupKeys: Array<Scalars['String']['input']>;
  targetPosition: Scalars['Int']['input'];
};


export type MutationReleaseDealControlArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationReopenDealNegotiationArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationRestoreDealItemsHistoryArgs = {
  dealId: Scalars['ID']['input'];
  items: Array<RestoreDealItemInput>;
};


export type MutationRestoreDealVersionArgs = {
  dealId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationSyncImagesArgs = {
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']>;
};


export type MutationTakeDealControlArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationTriggerCategorizeDealItemsArgs = {
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']>;
  forceRecategorize: Scalars['Boolean']['input'];
};


export type MutationUpdateDealGoogleDriveImagesUrlArgs = {
  dealId: Scalars['ID']['input'];
  googleDriveImagesUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDealItemsV2Args = {
  dealId: Scalars['ID']['input'];
  items: Array<DealItemUpdateInput>;
};


export type MutationUpdateDealPricingModeArgs = {
  dealId: Scalars['ID']['input'];
  pricingMode: PricingMode;
};


export type MutationUpdateDealSetupNoteArgs = {
  dealId: Scalars['ID']['input'];
  setupNote: Scalars['String']['input'];
};


export type MutationValidateDealSelectionArgs = {
  dealId: Scalars['ID']['input'];
};

export type MutationReturn = DomainException | MutationSuccess;

export type MutationSuccess = {
  __typename?: 'MutationSuccess';
  id: Scalars['ID']['output'];
};

export type MutationUpdateDealItemsReturn = DomainException | MutationUpdateDealItemsSuccess;

export type MutationUpdateDealItemsSuccess = {
  __typename?: 'MutationUpdateDealItemsSuccess';
  updates: Array<DealItemUpdate>;
};

export type OfferEvolutionInsightsV2 = {
  __typename?: 'OfferEvolutionInsightsV2';
  /** New items that weren't in the previous sale */
  addedProducts: Array<Scalars['ID']['output']>;
  campaignItemsWithEvolution: Array<CampaignItem>;
  /** Items with higher discounts compared to previous sale */
  discountIncreases: Array<Scalars['ID']['output']>;
  /** Items with lower discounts compared to previous sale */
  discountReductions: Array<Scalars['ID']['output']>;
  /** Items with lower stock compared to previous sale */
  stockReductions: Array<Scalars['ID']['output']>;
};

export type OfferKpis = {
  __typename?: 'OfferKpis';
  avgChoosePrice?: Maybe<Scalars['Float']['output']>;
  avgDiscount?: Maybe<Scalars['Float']['output']>;
  avgMargin?: Maybe<Scalars['Float']['output']>;
  productsCount: Scalars['Int']['output'];
  totalPotential?: Maybe<Scalars['Float']['output']>;
  totalStock: Scalars['Int']['output'];
};

/** Operation type */
export enum OperationType {
  /** Choose with StockAZ clears its stock */
  Clearance = 'CLEARANCE',
  /** The supplier sell its products and ship on its own */
  DropShipping = 'DROP_SHIPPING',
  /** Choose has ordered the products before the operation and ship on its own */
  FirmPurchase = 'FIRM_PURCHASE',
  /** Choose order the products sold after the operation and ship it on its own */
  PostOperationPurchase = 'POST_OPERATION_PURCHASE',
  /** The reseller sell products from another supplier => Not used anymore */
  Reseller = 'RESELLER'
}

export enum PickupPointNetwork {
  MondialRelay = 'mondialRelay',
  Shop2shop = 'shop2shop'
}

export type PostRegisterConfig = {
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type PresenceUser = {
  __typename?: 'PresenceUser';
  isInternal: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type PreviousCampaignDataSource = {
  __typename?: 'PreviousCampaignDataSource';
  author?: Maybe<Author>;
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  errors: Array<DataSourceError>;
  id: Scalars['ID']['output'];
  importSummary?: Maybe<ImportSummary>;
  instructions: DataSourceInstructions;
  saleId: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: DataSourceStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PricingMode {
  BuyingPriceFixed = 'BUYING_PRICE_FIXED',
  MarginFixed = 'MARGIN_FIXED'
}

export type ProductCategoryType = {
  __typename?: 'ProductCategoryType';
  label: Scalars['String']['output'];
  productCategoryId: Scalars['ID']['output'];
  shortLabel: Scalars['String']['output'];
};

export enum ProductType {
  Coupon = 'coupon',
  Object = 'object'
}

export enum PsychologicalPriceStrategy {
  Comma = 'comma',
  Round = 'round'
}

export type Query = {
  __typename?: 'Query';
  /** Get all country labels */
  allCountryLabels: Array<CountryLabel>;
  /** Auth queries */
  authQueries: AuthQueries;
  /**
   * **Get the categories and their sub categories as a tree list**
   *
   * This query supports HTTP GET requests for better caching with language parameter.
   * Each language parameter value results in a separate cache entry.
   *
   * Example: GET /graphql?query=query($language:LanguageIso6391){categoryTree(language:$language){id label}}&variables={"language":"fr_FR"}
   */
  categoryTree: Array<CategoryTree>;
  /** Get a deal by its ID */
  deal?: Maybe<Deal>;
  /** Get KPIs for the current deal and optionally compare to a previous sale by compareToSaleId */
  dealKpis: DealKpisResult;
  /** Get the presence of a deal */
  dealPresence: DealPresence;
  /** Get a signed download URL for a selection export (only generated when requested) */
  dealSelectionExportDownloadUrl: Scalars['String']['output'];
  /** Get a version of a deal with their validation status */
  dealVersion?: Maybe<DealVersion>;
  /** Get all versions of a deal with their validation status */
  dealVersions: Array<DealVersion>;
  /**
   * Get all available deals
   * @deprecated
   * This query is deprecated and will be removed in the future.
   */
  deals: Array<Deal>;
  getBrandApiKey?: Maybe<Scalars['String']['output']>;
  getShopifyCollections?: Maybe<ShopifyQueryReturn>;
  /**
   * Get all products from a sale filtered by brand ID
   * Returns products with basic information for preview purposes
   */
  saleProductsPreview: Array<SaleProductPreview>;
  /**
   * Get the live Shopify bulk operation status for a deal's latest import.
   * Frontend polls this to show "Import in progress: XXX products".
   * Returns null when no pending bulk operation exists.
   */
  shopifyBulkOperationStatus?: Maybe<ShopifyBulkOperationStatus>;
  /** Get top 10 country labels */
  topCountryLabels: Array<CountryLabel>;
};


export type QueryCategoryTreeArgs = {
  language?: InputMaybe<LanguageIso6391>;
};


export type QueryDealArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealKpisArgs = {
  compareToSaleId?: InputMaybe<Scalars['ID']['input']>;
  dealId: Scalars['ID']['input'];
};


export type QueryDealPresenceArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealSelectionExportDownloadUrlArgs = {
  exportId: Scalars['ID']['input'];
};


export type QueryDealVersionArgs = {
  dealId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type QueryDealVersionsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryGetBrandApiKeyArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryGetShopifyCollectionsArgs = {
  dealId: Scalars['ID']['input'];
  status?: InputMaybe<Array<ShopifyProductStatus>>;
};


export type QuerySaleProductsPreviewArgs = {
  brandId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
};


export type QueryShopifyBulkOperationStatusArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryTopCountryLabelsArgs = {
  store: StoreRegion;
};

export type RestoreDealItemInput = {
  currentHistoryId: Scalars['ID']['input'];
  dealItemId: Scalars['ID']['input'];
  previousHistoryId: Scalars['ID']['input'];
};

export type SaleProductPreview = {
  __typename?: 'SaleProductPreview';
  /** Product image URL */
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Product price in cents including tax */
  price: Scalars['Int']['output'];
  /** Source sale ID */
  saleId: Scalars['ID']['output'];
  /** Available stock quantity */
  stock: Scalars['Int']['output'];
};

export type SelectionExportError = {
  __typename?: 'SelectionExportError';
  code?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  documentTitle?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  step: Scalars['String']['output'];
};

export type ShopifyBulkOperationStatus = {
  __typename?: 'ShopifyBulkOperationStatus';
  objectCount: Scalars['Int']['output'];
  status: ShopifyBulkOperationStatusEnum;
};

export enum ShopifyBulkOperationStatusEnum {
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type ShopifyCatalogDataSource = {
  __typename?: 'ShopifyCatalogDataSource';
  author?: Maybe<Author>;
  createdAt: Scalars['DateTime']['output'];
  errors: Array<DataSourceError>;
  id: Scalars['ID']['output'];
  importSummary?: Maybe<ImportSummary>;
  instructions: DataSourceInstructions;
  source: Scalars['String']['output'];
  status: DataSourceStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShopifyCollection = {
  __typename?: 'ShopifyCollection';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productsCount: Scalars['Int']['output'];
  productsFilteredCount: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type ShopifyCollectionInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ShopifyCollectionSuccess = {
  __typename?: 'ShopifyCollectionSuccess';
  collections: Array<ShopifyCollection>;
};

export enum ShopifyProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Unlisted = 'UNLISTED'
}

export type ShopifyQueryReturn = DomainException | ShopifyCollectionSuccess;

export enum StoreRegion {
  Fr = 'fr',
  Us = 'us'
}

export type Subscription = {
  __typename?: 'Subscription';
  dealItemsUpdatedV2: Array<DealItemUpdated>;
  dealItemsUpdatedV3: DealItemsUpdated;
  /**
   * Subscribe to real-time presence updates for a deal page
   * Returns the list of users currently viewing the page
   */
  dealPresence: DealPresence;
  dealSelectionExportsUpdated: Array<DealSelectionExport>;
  dealUpdated: Deal;
  shopifyInstalled: Scalars['String']['output'];
};


export type SubscriptionDealItemsUpdatedV2Args = {
  dealId: Scalars['ID']['input'];
};


export type SubscriptionDealItemsUpdatedV3Args = {
  dealId: Scalars['ID']['input'];
};


export type SubscriptionDealPresenceArgs = {
  dealId: Scalars['ID']['input'];
};


export type SubscriptionDealSelectionExportsUpdatedArgs = {
  dealId: Scalars['ID']['input'];
};


export type SubscriptionDealUpdatedArgs = {
  dealId: Scalars['ID']['input'];
};


export type SubscriptionShopifyInstalledArgs = {
  brandId: Scalars['ID']['input'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  createdAt: Scalars['DateTime']['output'];
  dealItemId: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  fixSuggestion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  ruleId: ValidationRuleId;
  /** @deprecated No longer supported */
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
};

export enum ValidationRuleId {
  DiscountConsistency = 'discount_consistency',
  DuplicateGtin = 'duplicate_gtin',
  DuplicateSku = 'duplicate_sku',
  DuplicateVariant = 'duplicate_variant',
  GtinValidness = 'gtin_validness',
  PositiveStock = 'positive_stock',
  PriceCompetitiveness = 'price_competitiveness',
  PsychologicalPriceApplication = 'psychological_price_application',
  RequiredFields = 'required_fields',
  SkuOrGtin = 'sku_or_gtin',
  Url_404Check = 'url_404_check',
  UrlOrDescriptionImagesOrDriveLink = 'url_or_description_images_or_drive_link'
}

export type Viewer = {
  __typename?: 'Viewer';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataSource = {
  __typename?: 'WebsiteDataSource';
  author?: Maybe<Author>;
  cms: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errors: Array<DataSourceError>;
  id: Scalars['ID']['output'];
  importSummary?: Maybe<ImportSummary>;
  instructions: DataSourceInstructions;
  productUrl?: Maybe<Scalars['String']['output']>;
  status: DataSourceStatus;
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataSourceParamsInput = {
  productUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatedDealItemFieldsFragment = { __typename?: 'DealItem', listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, marginPercentage?: number | null, stockQuantity?: number | null, potentialSalesVolume?: number | null, vatRate?: number | null, eeePrice?: number | null };

export type DataSourceInstructionsFieldsFragment = { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null };

export type GetDealItemsByDealIdQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetDealItemsByDealIdQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: string, dealItemsWithVersions: Array<{ __typename?: 'DealItemWithVersions', id: string, activeVersion: { __typename?: 'DealItem', id: string, isSelected: boolean, hasVatMargin: boolean, name: string, sku?: string | null, gtin?: string | null, shopifyVariantId?: string | null, isBestSeller?: boolean | null, bestSellerQuantitySold?: number | null, images: Array<string>, listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, hasDescription: boolean, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, vatRate?: number | null, marginPercentage?: number | null, potentialSalesVolume?: number | null, stockQuantity?: number | null, sourceUrl?: string | null, madeIn?: string | null, productType: ProductType, couponExpirationDate?: Date | null, couponTerms?: Array<string> | null, eeePrice?: number | null, couponHowToUse?: Array<string> | null, updatingFields: Array<string>, productGroupKey: string, position?: number | null, historyId: string, options?: Array<{ __typename?: 'DealItemGenericProperty', name: string, value: string }> | null, productCategory?: { __typename?: 'ProductCategoryType', productCategoryId: string } | null }, lastBrandVersion?: { __typename?: 'DealItem', listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, marginPercentage?: number | null, stockQuantity?: number | null, potentialSalesVolume?: number | null, vatRate?: number | null, eeePrice?: number | null } | null, lastChooseVersion?: { __typename?: 'DealItem', listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, marginPercentage?: number | null, stockQuantity?: number | null, potentialSalesVolume?: number | null, vatRate?: number | null, eeePrice?: number | null } | null }> } | null };

export type GetDealItemsValidationErrorsQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetDealItemsValidationErrorsQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: string, dealItemsWithVersions: Array<{ __typename?: 'DealItemWithVersions', id: string, activeVersion: { __typename?: 'DealItem', id: string, validationErrors: Array<{ __typename?: 'ValidationError', id: string, dealItemId: string, createdAt: Date, ruleId: ValidationRuleId, message: string, severity: string }> } }> } | null };

export type GetDealItemsDescriptionsQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetDealItemsDescriptionsQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: string, dealItemsWithVersions: Array<{ __typename?: 'DealItemWithVersions', id: string, activeVersion: { __typename?: 'DealItem', id: string, description?: string | null } }> } | null };

export type GetShopifyCollectionsQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
  status: Array<ShopifyProductStatus> | ShopifyProductStatus;
}>;


export type GetShopifyCollectionsQuery = { __typename?: 'Query', getShopifyCollections?: { __typename?: 'DomainException', code: string } | { __typename?: 'ShopifyCollectionSuccess', collections: Array<{ __typename?: 'ShopifyCollection', id: string, name: string, productsCount: number, productsFilteredCount: number, selected: boolean }> } | null };

export type GetDealByIdQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetDealByIdQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: string, hubspotDealId: string, brandId?: string | null, activeVersionId: string, state: DealState, editionMode: ActorRole, setupNote?: string | null, googleDriveImagesUrl?: string | null, googleAnalyzeFileUrl?: string | null, hasCouponCodesFile: boolean, pricingMode: PricingMode, createdAt: Date, updatedAt: Date, activeVersion: { __typename?: 'DealVersion', id: string, dealId: string, versionNumber: number, status: DealVersionStatus, isValidatedByBrand: boolean, isValidatedByChoose: boolean }, hubspotInfos: { __typename?: 'HubspotInfos', dealName: string, startDate: Date, store: StoreRegion, dealManager?: { __typename?: 'HubspotDealManager', id: string, name: string, photoUrl: string, email?: string | null } | null }, latestPreviousCampaigns: Array<{ __typename?: 'Campaign', saleId: string, name: string, numberOfProducts: number, revenue?: number | null, startAt: Date }>, externalCatalogConnections: Array<{ __typename?: 'ExternalCatalogConnection', id: string, cms: ExternalCatalogConnectionCms, isActive: boolean }>, dealShippingPolicy?: { __typename?: 'DealShippingPolicy', id: string, freeShippingMinimumOrderAmount?: number | null, deliveryOfferedNumberOfDays?: number | null, pickupPointNetwork?: PickupPointNetwork | null, basicFrPickupPointDeliveryPrice?: number | null } | null, dataSources: Array<{ __typename?: 'CSVDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, signedUrl?: string | null, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'ExternalCatalogDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'PreviousCampaignDataSource', id: string, brandId: string, saleId: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'ShopifyCatalogDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'WebsiteDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, cms: string, websiteUrl?: string | null, productUrl?: string | null, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> }>, selectionExports: Array<{ __typename?: 'DealSelectionExport', id: string, status: string, downloadUrlAvailable: boolean, createdAt: Date, updatedAt: Date, errors: Array<{ __typename?: 'SelectionExportError', step: string, code?: string | null, operation?: string | null, documentTitle?: string | null, fileId?: string | null }> }> } | null };

export type GetDatasourceQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetDatasourceQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: string, dataSources: Array<{ __typename?: 'CSVDataSource', id: string, status: DataSourceStatus, signedUrl?: string | null, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, errors: Array<{ __typename?: 'DataSourceError', message: string, code?: string | null }>, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, importSummary?: { __typename?: 'ImportSummary', itemsCreatedIds: Array<string>, selectedItemsUpdatedIds: Array<string>, itemsSkippedIds: Array<string>, excludedItemsUpdatedIds: Array<string> } | null } | { __typename?: 'ExternalCatalogDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, errors: Array<{ __typename?: 'DataSourceError', message: string, code?: string | null }>, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null } | { __typename?: 'PreviousCampaignDataSource', id: string, status: DataSourceStatus, saleId: string, brandId: string, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, errors: Array<{ __typename?: 'DataSourceError', message: string, code?: string | null }>, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, importSummary?: { __typename?: 'ImportSummary', itemsCreatedIds: Array<string>, selectedItemsUpdatedIds: Array<string>, itemsSkippedIds: Array<string>, excludedItemsUpdatedIds: Array<string> } | null } | { __typename?: 'ShopifyCatalogDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, errors: Array<{ __typename?: 'DataSourceError', message: string, code?: string | null }>, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, importSummary?: { __typename?: 'ImportSummary', itemsCreatedIds: Array<string>, selectedItemsUpdatedIds: Array<string>, itemsSkippedIds: Array<string>, excludedItemsUpdatedIds: Array<string> } | null } | { __typename?: 'WebsiteDataSource', id: string, status: DataSourceStatus, websiteUrl?: string | null, productUrl?: string | null, createdAt: Date, updatedAt: Date, cms: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, errors: Array<{ __typename?: 'DataSourceError', message: string, code?: string | null }>, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, importSummary?: { __typename?: 'ImportSummary', itemsCreatedIds: Array<string>, selectedItemsUpdatedIds: Array<string>, itemsSkippedIds: Array<string>, excludedItemsUpdatedIds: Array<string> } | null }> } | null };

export type AddShopifyDataSourceToDealMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  collections?: InputMaybe<Array<ShopifyCollectionInput> | ShopifyCollectionInput>;
  status?: InputMaybe<Array<ShopifyProductStatus> | ShopifyProductStatus>;
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
  fields?: InputMaybe<Array<DatasourceInstructionUpdateField> | DatasourceInstructionUpdateField>;
  dealItemsIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  skus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  gtins?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddShopifyDataSourceToDealMutation = { __typename?: 'Mutation', addShopifyDataSourceToDeal: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type GetShopifyBulkOperationStatusQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetShopifyBulkOperationStatusQuery = { __typename?: 'Query', shopifyBulkOperationStatus?: { __typename?: 'ShopifyBulkOperationStatus', status: ShopifyBulkOperationStatusEnum, objectCount: number } | null };

export type AddWebsiteDataSourceToDealMutationVariables = Exact<{
  hubspotDealId: Scalars['ID']['input'];
  dataSourceParams: WebsiteDataSourceParamsInput;
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
}>;


export type AddWebsiteDataSourceToDealMutation = { __typename?: 'Mutation', addWebsiteDataSourceToDeal: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type UpdateDealItemsV2MutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  items: Array<DealItemUpdateInput> | DealItemUpdateInput;
}>;


export type UpdateDealItemsV2Mutation = { __typename?: 'Mutation', updateDealItemsV2: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationUpdateDealItemsSuccess', updates: Array<{ __typename?: 'DealItemUpdate', id: string, changedFields: Array<string>, previousHistoryId: string, currentHistoryId: string }> } };

export type RestoreDealItemsHistoryMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  items: Array<RestoreDealItemInput> | RestoreDealItemInput;
}>;


export type RestoreDealItemsHistoryMutation = { __typename?: 'Mutation', restoreDealItemsHistory: { __typename?: 'DomainException', code: string } | { __typename: 'MutationSuccess' } };

export type MoveProductsToPositionMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  productGroupKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  targetPosition: Scalars['Int']['input'];
}>;


export type MoveProductsToPositionMutation = { __typename?: 'Mutation', moveProductsToPosition: { __typename?: 'DomainException', code: string } | { __typename: 'MutationSuccess' } };

export type ValidateDealSelectionMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type ValidateDealSelectionMutation = { __typename?: 'Mutation', validateDealSelection: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type CloseDealNegotiationMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type CloseDealNegotiationMutation = { __typename?: 'Mutation', closeDealNegotiation: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type ReopenDealNegotiationMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type ReopenDealNegotiationMutation = { __typename?: 'Mutation', reopenDealNegotiation: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type DealItemsUpdatedV3SubscriptionVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type DealItemsUpdatedV3Subscription = { __typename?: 'Subscription', dealItemsUpdatedV3: { __typename?: 'DealItemsUpdated', items: Array<{ __typename?: 'DealItemUpdated', changedFields: Array<string>, dealItemWithVersions: { __typename?: 'DealItemWithVersions', id: string, activeVersion: { __typename?: 'DealItem', id: string, isSelected: boolean, hasVatMargin: boolean, name: string, sku?: string | null, gtin?: string | null, shopifyVariantId?: string | null, isBestSeller?: boolean | null, bestSellerQuantitySold?: number | null, eeePrice?: number | null, images: Array<string>, listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, hasDescription: boolean, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, vatRate?: number | null, marginPercentage?: number | null, potentialSalesVolume?: number | null, stockQuantity?: number | null, sourceUrl?: string | null, madeIn?: string | null, productType: ProductType, couponExpirationDate?: Date | null, couponTerms?: Array<string> | null, couponHowToUse?: Array<string> | null, updatingFields: Array<string>, productGroupKey: string, position?: number | null, historyId: string, options?: Array<{ __typename?: 'DealItemGenericProperty', name: string, value: string }> | null, productCategory?: { __typename?: 'ProductCategoryType', productCategoryId: string } | null, validationErrors: Array<{ __typename?: 'ValidationError', ruleId: ValidationRuleId, message: string, severity: string }> }, lastBrandVersion?: { __typename?: 'DealItem', listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, marginPercentage?: number | null, stockQuantity?: number | null, potentialSalesVolume?: number | null, vatRate?: number | null, eeePrice?: number | null } | null, lastChooseVersion?: { __typename?: 'DealItem', listPrice?: number | null, discountedPrice?: number | null, chooseDiscount?: number | null, choosePrice?: number | null, buyingPrice?: number | null, shippingPrice?: number | null, marginPercentage?: number | null, stockQuantity?: number | null, potentialSalesVolume?: number | null, vatRate?: number | null, eeePrice?: number | null } | null } }>, fromAction: { __typename?: 'Action', type: ActionType, datasourceId?: string | null } } };

export type DealUpdatedSubscriptionVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type DealUpdatedSubscription = { __typename?: 'Subscription', dealUpdated: { __typename?: 'Deal', id: string, hubspotDealId: string, brandId?: string | null, activeVersionId: string, state: DealState, editionMode: ActorRole, createdAt: Date, updatedAt: Date, hubspotInfos: { __typename?: 'HubspotInfos', dealName: string, startDate: Date, store: StoreRegion, dealManager?: { __typename?: 'HubspotDealManager', id: string, name: string, photoUrl: string, email?: string | null } | null }, dealShippingPolicy?: { __typename?: 'DealShippingPolicy', id: string, freeShippingMinimumOrderAmount?: number | null, deliveryOfferedNumberOfDays?: number | null, basicFrPickupPointDeliveryPrice?: number | null, pickupPointNetwork?: PickupPointNetwork | null } | null, dataSources: Array<{ __typename?: 'CSVDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, signedUrl?: string | null, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'ExternalCatalogDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'PreviousCampaignDataSource', id: string, brandId: string, saleId: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'ShopifyCatalogDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, source: string, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> } | { __typename?: 'WebsiteDataSource', id: string, status: DataSourceStatus, createdAt: Date, updatedAt: Date, cms: string, websiteUrl?: string | null, productUrl?: string | null, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null }, author?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null, errors: Array<{ __typename?: 'DataSourceError', step: string, code?: string | null, message: string }> }> } };

export type DealVersionsQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type DealVersionsQuery = { __typename?: 'Query', dealVersions: Array<{ __typename?: 'DealVersion', id: string, dealId: string, versionNumber: number, status: DealVersionStatus, isValidatedByBrand: boolean, isValidatedByChoose: boolean, createdAt: Date, updatedAt: Date, createdBy?: { __typename?: 'Author', id: string, name?: string | null, email?: string | null, actorRole: ActorRole } | null }> };

export type CreateDealItemMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  item: DealItemCreateInput;
}>;


export type CreateDealItemMutation = { __typename?: 'Mutation', createDealItem: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type ExportDealSelectionMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  template: ExportTemplate;
  language: LanguageIso6391;
}>;


export type ExportDealSelectionMutation = { __typename?: 'Mutation', exportDealSelection: { __typename: 'DomainException', code: string } | { __typename: 'MutationSuccess', id: string } };

export type ExportDealForAnalyseMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  language?: InputMaybe<LanguageIso6391>;
  prompt?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportDealForAnalyseMutation = { __typename?: 'Mutation', exportDealForAnalyse: { __typename: 'DomainException', code: string } | { __typename: 'MutationSuccess', id: string } };

export type WatchDealSelectionExportsSubscriptionVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type WatchDealSelectionExportsSubscription = { __typename?: 'Subscription', dealSelectionExportsUpdated: Array<{ __typename?: 'DealSelectionExport', id: string, status: string, dealId: string, downloadUrlAvailable: boolean, createdAt: Date, updatedAt: Date, errors: Array<{ __typename?: 'SelectionExportError', step: string, code?: string | null, operation?: string | null, documentTitle?: string | null, fileId?: string | null }> }> };

export type GetDealSelectionExportDownloadUrlQueryVariables = Exact<{
  exportId: Scalars['ID']['input'];
}>;


export type GetDealSelectionExportDownloadUrlQuery = { __typename?: 'Query', dealSelectionExportDownloadUrl: string };

export type GetAllCountryLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountryLabelsQuery = { __typename?: 'Query', allCountryLabels: Array<{ __typename?: 'CountryLabel', code: string, fr?: string | null, en?: string | null }> };

export type GetTopCountryLabelsQueryVariables = Exact<{
  store: StoreRegion;
}>;


export type GetTopCountryLabelsQuery = { __typename?: 'Query', topCountryLabels: Array<{ __typename?: 'CountryLabel', code: string, fr?: string | null, en?: string | null }> };

export type GetCsvTemplateMutationVariables = Exact<{
  templateId: CsvTemplate;
  language: LanguageIso6391;
}>;


export type GetCsvTemplateMutation = { __typename?: 'Mutation', exportDealCsvTemplate: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type AddCsvDataSourceToDealMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
  anchorKey?: InputMaybe<DealItemAnchorKey>;
  eMerchCustomFieldsHeaders?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddCsvDataSourceToDealMutation = { __typename?: 'Mutation', addCsvDataSourceToDeal: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type AddCouponCodesCsvDataSourceToDealMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type AddCouponCodesCsvDataSourceToDealMutation = { __typename?: 'Mutation', addCouponCodesCsvDataSourceToDeal: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type GetSignedUrlQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type GetSignedUrlQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', dataSources: Array<{ __typename?: 'CSVDataSource', id: string, signedUrl?: string | null, instructions: { __typename?: 'DataSourceInstructions', instructionMode: DatasourceInstructionMode, notify: boolean, anchorKey?: DealItemAnchorKey | null, dealItemIds?: Array<string> | null, fields?: Array<DatasourceInstructionUpdateField> | null } } | { __typename?: 'ExternalCatalogDataSource' } | { __typename?: 'PreviousCampaignDataSource' } | { __typename?: 'ShopifyCatalogDataSource' } | { __typename?: 'WebsiteDataSource' }> } | null };

export type MarkDataSourceAsImportedMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dataSourceId: Scalars['ID']['input'];
}>;


export type MarkDataSourceAsImportedMutation = { __typename?: 'Mutation', markDataSourceAsImported: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type EditDealShippingPolicyMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  shippingPolicy: DealShippingPolicyInput;
}>;


export type EditDealShippingPolicyMutation = { __typename?: 'Mutation', editDealShippingPolicy: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type DeleteDealItemsMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;


export type DeleteDealItemsMutation = { __typename?: 'Mutation', deleteDealItems: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type ComputeChoosePriceMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  strategy: PsychologicalPriceStrategy;
}>;


export type ComputeChoosePriceMutation = { __typename?: 'Mutation', computeChoosePriceV2: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationUpdateDealItemsSuccess', updates: Array<{ __typename?: 'DealItemUpdate', id: string, changedFields: Array<string>, previousHistoryId: string, currentHistoryId: string }> } };

export type CategoryTreeQueryVariables = Exact<{
  language?: InputMaybe<LanguageIso6391>;
}>;


export type CategoryTreeQuery = { __typename?: 'Query', categoryTree: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean }> | null }> | null }> | null }> | null }> | null }> | null }> };

export type RestoreDealVersionMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
}>;


export type RestoreDealVersionMutation = { __typename?: 'Mutation', restoreDealVersion: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type AddPreviousCampaignToDealMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  instructionMode?: InputMaybe<DatasourceInstructionMode>;
}>;


export type AddPreviousCampaignToDealMutation = { __typename?: 'Mutation', addPreviousCampaignToDeal: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type GetSaleProductsPreviewQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
}>;


export type GetSaleProductsPreviewQuery = { __typename?: 'Query', saleProductsPreview: Array<{ __typename?: 'SaleProductPreview', name: string, image?: string | null, price: number, stock: number, saleId: string }> };

export type GetDealKpisQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
  compareToSaleId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDealKpisQuery = { __typename?: 'Query', dealKpis: { __typename?: 'DealKpisResult', currentDealKpis: { __typename?: 'OfferKpis', avgChoosePrice?: number | null, avgDiscount?: number | null, avgMargin?: number | null, productsCount: number, totalPotential?: number | null, totalStock: number }, previousCampaignKpis?: { __typename?: 'OfferKpis', avgChoosePrice?: number | null, avgDiscount?: number | null, avgMargin?: number | null, productsCount: number, totalPotential?: number | null, totalStock: number } | null, evolutionInsightsV2?: { __typename?: 'OfferEvolutionInsightsV2', discountReductions: Array<string>, discountIncreases: Array<string>, stockReductions: Array<string>, addedProducts: Array<string>, campaignItemsWithEvolution: Array<{ __typename?: 'CampaignItem', dealItemId: string, listPrice?: number | null, chooseDiscount?: number | null, choosePrice?: number | null, stockQuantity?: number | null }> } | null } };

export type SyncImagesMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SyncImagesMutation = { __typename?: 'Mutation', syncImages: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type TriggerCategorizeDealItemsMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  forceRecategorize: Scalars['Boolean']['input'];
}>;


export type TriggerCategorizeDealItemsMutation = { __typename?: 'Mutation', triggerCategorizeDealItems: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type ExtractColorFromImagesMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealItemsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExtractColorFromImagesMutation = { __typename?: 'Mutation', extractColorFromImages: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type UpdateDealSetupNoteMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  setupNote: Scalars['String']['input'];
}>;


export type UpdateDealSetupNoteMutation = { __typename?: 'Mutation', updateDealSetupNote: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type UpdateDealGoogleDriveImagesUrlMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  googleDriveImagesUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDealGoogleDriveImagesUrlMutation = { __typename?: 'Mutation', updateDealGoogleDriveImagesUrl: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type DealPresenceSubscriptionVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type DealPresenceSubscription = { __typename?: 'Subscription', dealPresence: { __typename?: 'DealPresence', dealId: string, users: Array<{ __typename?: 'PresenceUser', userId: string, username: string, lastViewedAt?: Date | null, lastUpdatedAt?: Date | null, isInternal: boolean, isOnline: boolean }> } };

export type DealPresencesQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type DealPresencesQuery = { __typename?: 'Query', dealPresence: { __typename?: 'DealPresence', dealId: string, users: Array<{ __typename?: 'PresenceUser', userId: string, username: string, lastViewedAt?: Date | null, lastUpdatedAt?: Date | null, isInternal: boolean, isOnline: boolean }> } };

export type EditPricingModeMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  pricingMode: PricingMode;
}>;


export type EditPricingModeMutation = { __typename?: 'Mutation', updateDealPricingMode: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type TakeDealControlMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type TakeDealControlMutation = { __typename?: 'Mutation', takeDealControl: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type ReleaseDealControlMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;


export type ReleaseDealControlMutation = { __typename?: 'Mutation', releaseDealControl: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } };

export type GetBrandApiKeyQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type GetBrandApiKeyQuery = { __typename?: 'Query', getBrandApiKey?: string | null };

export type ShopifyPluginInstalledSubscriptionVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type ShopifyPluginInstalledSubscription = { __typename?: 'Subscription', shopifyInstalled: string };

export type PostRegisterMutationVariables = Exact<{
  config: PostRegisterConfig;
}>;


export type PostRegisterMutation = { __typename?: 'Mutation', authMutations: { __typename?: 'AuthMutations', postRegister: { __typename?: 'DomainException', code: string } | { __typename?: 'MutationSuccess', id: string } } };

export const ValidatedDealItemFieldsFragmentDoc = gql`
    fragment ValidatedDealItemFields on DealItem {
  listPrice
  discountedPrice
  chooseDiscount
  choosePrice
  buyingPrice
  shippingPrice
  marginPercentage
  stockQuantity
  potentialSalesVolume
  vatRate
  eeePrice
}
    `;
export const DataSourceInstructionsFieldsFragmentDoc = gql`
    fragment DataSourceInstructionsFields on DataSourceInstructions {
  instructionMode
  notify
  anchorKey
  dealItemIds
  fields
}
    `;
export const GetDealItemsByDealIdDocument = gql`
    query GetDealItemsByDealId($dealId: ID!) {
  deal(dealId: $dealId) {
    id
    dealItemsWithVersions {
      id
      activeVersion {
        id
        isSelected
        hasVatMargin
        name
        sku
        gtin
        shopifyVariantId
        options {
          name
          value
        }
        productCategory {
          productCategoryId
        }
        isBestSeller
        bestSellerQuantitySold
        images
        listPrice
        discountedPrice
        chooseDiscount
        hasDescription
        choosePrice
        buyingPrice
        shippingPrice
        vatRate
        marginPercentage
        potentialSalesVolume
        stockQuantity
        sourceUrl
        madeIn
        productType
        couponExpirationDate
        couponTerms
        eeePrice
        couponHowToUse
        updatingFields
        productGroupKey
        position
        historyId
      }
      lastBrandVersion {
        ...ValidatedDealItemFields
      }
      lastChooseVersion {
        ...ValidatedDealItemFields
      }
    }
  }
}
    ${ValidatedDealItemFieldsFragmentDoc}`;

/**
 * __useGetDealItemsByDealIdQuery__
 *
 * To run a query within a React component, call `useGetDealItemsByDealIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealItemsByDealIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealItemsByDealIdQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetDealItemsByDealIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables> & ({ variables: GetDealItemsByDealIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables>(GetDealItemsByDealIdDocument, options);
      }
export function useGetDealItemsByDealIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables>(GetDealItemsByDealIdDocument, options);
        }
export function useGetDealItemsByDealIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables>(GetDealItemsByDealIdDocument, options);
        }
export type GetDealItemsByDealIdQueryHookResult = ReturnType<typeof useGetDealItemsByDealIdQuery>;
export type GetDealItemsByDealIdLazyQueryHookResult = ReturnType<typeof useGetDealItemsByDealIdLazyQuery>;
export type GetDealItemsByDealIdSuspenseQueryHookResult = ReturnType<typeof useGetDealItemsByDealIdSuspenseQuery>;
export type GetDealItemsByDealIdQueryResult = Apollo.QueryResult<GetDealItemsByDealIdQuery, GetDealItemsByDealIdQueryVariables>;
export const GetDealItemsValidationErrorsDocument = gql`
    query GetDealItemsValidationErrors($dealId: ID!) {
  deal(dealId: $dealId) {
    id
    dealItemsWithVersions {
      id
      activeVersion {
        id
        validationErrors {
          id
          dealItemId
          createdAt
          ruleId
          message
          severity
        }
      }
    }
  }
}
    `;

/**
 * __useGetDealItemsValidationErrorsQuery__
 *
 * To run a query within a React component, call `useGetDealItemsValidationErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealItemsValidationErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealItemsValidationErrorsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetDealItemsValidationErrorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables> & ({ variables: GetDealItemsValidationErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables>(GetDealItemsValidationErrorsDocument, options);
      }
export function useGetDealItemsValidationErrorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables>(GetDealItemsValidationErrorsDocument, options);
        }
export function useGetDealItemsValidationErrorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables>(GetDealItemsValidationErrorsDocument, options);
        }
export type GetDealItemsValidationErrorsQueryHookResult = ReturnType<typeof useGetDealItemsValidationErrorsQuery>;
export type GetDealItemsValidationErrorsLazyQueryHookResult = ReturnType<typeof useGetDealItemsValidationErrorsLazyQuery>;
export type GetDealItemsValidationErrorsSuspenseQueryHookResult = ReturnType<typeof useGetDealItemsValidationErrorsSuspenseQuery>;
export type GetDealItemsValidationErrorsQueryResult = Apollo.QueryResult<GetDealItemsValidationErrorsQuery, GetDealItemsValidationErrorsQueryVariables>;
export const GetDealItemsDescriptionsDocument = gql`
    query GetDealItemsDescriptions($dealId: ID!) {
  deal(dealId: $dealId) {
    id
    dealItemsWithVersions {
      id
      activeVersion {
        id
        description
      }
    }
  }
}
    `;

/**
 * __useGetDealItemsDescriptionsQuery__
 *
 * To run a query within a React component, call `useGetDealItemsDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealItemsDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealItemsDescriptionsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetDealItemsDescriptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables> & ({ variables: GetDealItemsDescriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables>(GetDealItemsDescriptionsDocument, options);
      }
export function useGetDealItemsDescriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables>(GetDealItemsDescriptionsDocument, options);
        }
export function useGetDealItemsDescriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables>(GetDealItemsDescriptionsDocument, options);
        }
export type GetDealItemsDescriptionsQueryHookResult = ReturnType<typeof useGetDealItemsDescriptionsQuery>;
export type GetDealItemsDescriptionsLazyQueryHookResult = ReturnType<typeof useGetDealItemsDescriptionsLazyQuery>;
export type GetDealItemsDescriptionsSuspenseQueryHookResult = ReturnType<typeof useGetDealItemsDescriptionsSuspenseQuery>;
export type GetDealItemsDescriptionsQueryResult = Apollo.QueryResult<GetDealItemsDescriptionsQuery, GetDealItemsDescriptionsQueryVariables>;
export const GetShopifyCollectionsDocument = gql`
    query GetShopifyCollections($dealId: ID!, $status: [ShopifyProductStatus!]!) {
  getShopifyCollections(dealId: $dealId, status: $status) {
    ... on ShopifyCollectionSuccess {
      collections {
        id
        name
        productsCount
        productsFilteredCount
        selected
      }
    }
    ... on DomainException {
      code
    }
  }
}
    `;

/**
 * __useGetShopifyCollectionsQuery__
 *
 * To run a query within a React component, call `useGetShopifyCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopifyCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopifyCollectionsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetShopifyCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables> & ({ variables: GetShopifyCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables>(GetShopifyCollectionsDocument, options);
      }
export function useGetShopifyCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables>(GetShopifyCollectionsDocument, options);
        }
export function useGetShopifyCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables>(GetShopifyCollectionsDocument, options);
        }
export type GetShopifyCollectionsQueryHookResult = ReturnType<typeof useGetShopifyCollectionsQuery>;
export type GetShopifyCollectionsLazyQueryHookResult = ReturnType<typeof useGetShopifyCollectionsLazyQuery>;
export type GetShopifyCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetShopifyCollectionsSuspenseQuery>;
export type GetShopifyCollectionsQueryResult = Apollo.QueryResult<GetShopifyCollectionsQuery, GetShopifyCollectionsQueryVariables>;
export const GetDealByIdDocument = gql`
    query GetDealById($dealId: ID!) {
  deal(dealId: $dealId) {
    id
    hubspotDealId
    brandId
    activeVersionId
    activeVersion {
      id
      dealId
      versionNumber
      status
      isValidatedByBrand
      isValidatedByChoose
    }
    hubspotInfos {
      dealName
      dealManager {
        id
        name
        photoUrl
        email
      }
      startDate
      store
      dealManager {
        id
        name
        photoUrl
      }
    }
    state
    editionMode
    setupNote
    googleDriveImagesUrl
    googleAnalyzeFileUrl
    hasCouponCodesFile
    pricingMode
    latestPreviousCampaigns {
      saleId
      name
      numberOfProducts
      revenue
      startAt
    }
    externalCatalogConnections {
      id
      cms
      isActive
    }
    dealShippingPolicy {
      id
      freeShippingMinimumOrderAmount
      deliveryOfferedNumberOfDays
      pickupPointNetwork
      basicFrPickupPointDeliveryPrice
    }
    dataSources {
      ... on WebsiteDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        cms
        websiteUrl
        productUrl
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
      }
      ... on CSVDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        source
        signedUrl
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
      }
      ... on PreviousCampaignDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        brandId
        saleId
        status
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
        source
      }
      ... on ShopifyCatalogDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
        source
      }
      ... on ExternalCatalogDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
        source
      }
    }
    createdAt
    updatedAt
    selectionExports {
      id
      status
      downloadUrlAvailable
      createdAt
      updatedAt
      errors {
        step
        code
        operation
        documentTitle
        fileId
      }
    }
  }
}
    ${DataSourceInstructionsFieldsFragmentDoc}`;

/**
 * __useGetDealByIdQuery__
 *
 * To run a query within a React component, call `useGetDealByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealByIdQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetDealByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealByIdQuery, GetDealByIdQueryVariables> & ({ variables: GetDealByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealByIdQuery, GetDealByIdQueryVariables>(GetDealByIdDocument, options);
      }
export function useGetDealByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealByIdQuery, GetDealByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealByIdQuery, GetDealByIdQueryVariables>(GetDealByIdDocument, options);
        }
export function useGetDealByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealByIdQuery, GetDealByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealByIdQuery, GetDealByIdQueryVariables>(GetDealByIdDocument, options);
        }
export type GetDealByIdQueryHookResult = ReturnType<typeof useGetDealByIdQuery>;
export type GetDealByIdLazyQueryHookResult = ReturnType<typeof useGetDealByIdLazyQuery>;
export type GetDealByIdSuspenseQueryHookResult = ReturnType<typeof useGetDealByIdSuspenseQuery>;
export type GetDealByIdQueryResult = Apollo.QueryResult<GetDealByIdQuery, GetDealByIdQueryVariables>;
export const GetDatasourceDocument = gql`
    query GetDatasource($dealId: ID!) {
  deal(dealId: $dealId) {
    id
    dataSources {
      ... on WebsiteDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        websiteUrl
        productUrl
        createdAt
        updatedAt
        cms
        errors {
          message
          code
        }
        author {
          id
          name
          email
          actorRole
        }
        importSummary {
          itemsCreatedIds
          selectedItemsUpdatedIds
          itemsSkippedIds
          excludedItemsUpdatedIds
        }
      }
      ... on CSVDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        signedUrl
        createdAt
        updatedAt
        errors {
          message
          code
        }
        author {
          id
          name
          email
          actorRole
        }
        source
        importSummary {
          itemsCreatedIds
          selectedItemsUpdatedIds
          itemsSkippedIds
          excludedItemsUpdatedIds
        }
      }
      ... on PreviousCampaignDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        saleId
        brandId
        errors {
          message
          code
        }
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        source
        importSummary {
          itemsCreatedIds
          selectedItemsUpdatedIds
          itemsSkippedIds
          excludedItemsUpdatedIds
        }
      }
      ... on ExternalCatalogDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        errors {
          message
          code
        }
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        source
      }
      ... on ShopifyCatalogDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        errors {
          message
          code
        }
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        source
        importSummary {
          itemsCreatedIds
          selectedItemsUpdatedIds
          itemsSkippedIds
          excludedItemsUpdatedIds
        }
      }
    }
  }
}
    ${DataSourceInstructionsFieldsFragmentDoc}`;

/**
 * __useGetDatasourceQuery__
 *
 * To run a query within a React component, call `useGetDatasourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasourceQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetDatasourceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDatasourceQuery, GetDatasourceQueryVariables> & ({ variables: GetDatasourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDatasourceQuery, GetDatasourceQueryVariables>(GetDatasourceDocument, options);
      }
export function useGetDatasourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDatasourceQuery, GetDatasourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDatasourceQuery, GetDatasourceQueryVariables>(GetDatasourceDocument, options);
        }
export function useGetDatasourceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDatasourceQuery, GetDatasourceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDatasourceQuery, GetDatasourceQueryVariables>(GetDatasourceDocument, options);
        }
export type GetDatasourceQueryHookResult = ReturnType<typeof useGetDatasourceQuery>;
export type GetDatasourceLazyQueryHookResult = ReturnType<typeof useGetDatasourceLazyQuery>;
export type GetDatasourceSuspenseQueryHookResult = ReturnType<typeof useGetDatasourceSuspenseQuery>;
export type GetDatasourceQueryResult = Apollo.QueryResult<GetDatasourceQuery, GetDatasourceQueryVariables>;
export const AddShopifyDataSourceToDealDocument = gql`
    mutation addShopifyDataSourceToDeal($dealId: ID!, $collections: [ShopifyCollectionInput!], $status: [ShopifyProductStatus!], $instructionMode: DatasourceInstructionMode, $fields: [DatasourceInstructionUpdateField!], $dealItemsIds: [ID!], $skus: [String!], $gtins: [String!]) {
  addShopifyDataSourceToDeal(
    dealId: $dealId
    collections: $collections
    status: $status
    instructionMode: $instructionMode
    fields: $fields
    dealItemsIds: $dealItemsIds
    skus: $skus
    gtins: $gtins
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type AddShopifyDataSourceToDealMutationFn = Apollo.MutationFunction<AddShopifyDataSourceToDealMutation, AddShopifyDataSourceToDealMutationVariables>;

/**
 * __useAddShopifyDataSourceToDealMutation__
 *
 * To run a mutation, you first call `useAddShopifyDataSourceToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShopifyDataSourceToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShopifyDataSourceToDealMutation, { data, loading, error }] = useAddShopifyDataSourceToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      collections: // value for 'collections'
 *      status: // value for 'status'
 *      instructionMode: // value for 'instructionMode'
 *      fields: // value for 'fields'
 *      dealItemsIds: // value for 'dealItemsIds'
 *      skus: // value for 'skus'
 *      gtins: // value for 'gtins'
 *   },
 * });
 */
export function useAddShopifyDataSourceToDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddShopifyDataSourceToDealMutation, AddShopifyDataSourceToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddShopifyDataSourceToDealMutation, AddShopifyDataSourceToDealMutationVariables>(AddShopifyDataSourceToDealDocument, options);
      }
export type AddShopifyDataSourceToDealMutationHookResult = ReturnType<typeof useAddShopifyDataSourceToDealMutation>;
export type AddShopifyDataSourceToDealMutationResult = Apollo.MutationResult<AddShopifyDataSourceToDealMutation>;
export type AddShopifyDataSourceToDealMutationOptions = Apollo.BaseMutationOptions<AddShopifyDataSourceToDealMutation, AddShopifyDataSourceToDealMutationVariables>;
export const GetShopifyBulkOperationStatusDocument = gql`
    query GetShopifyBulkOperationStatus($dealId: ID!) {
  shopifyBulkOperationStatus(dealId: $dealId) {
    status
    objectCount
  }
}
    `;

/**
 * __useGetShopifyBulkOperationStatusQuery__
 *
 * To run a query within a React component, call `useGetShopifyBulkOperationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopifyBulkOperationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopifyBulkOperationStatusQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetShopifyBulkOperationStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables> & ({ variables: GetShopifyBulkOperationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables>(GetShopifyBulkOperationStatusDocument, options);
      }
export function useGetShopifyBulkOperationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables>(GetShopifyBulkOperationStatusDocument, options);
        }
export function useGetShopifyBulkOperationStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables>(GetShopifyBulkOperationStatusDocument, options);
        }
export type GetShopifyBulkOperationStatusQueryHookResult = ReturnType<typeof useGetShopifyBulkOperationStatusQuery>;
export type GetShopifyBulkOperationStatusLazyQueryHookResult = ReturnType<typeof useGetShopifyBulkOperationStatusLazyQuery>;
export type GetShopifyBulkOperationStatusSuspenseQueryHookResult = ReturnType<typeof useGetShopifyBulkOperationStatusSuspenseQuery>;
export type GetShopifyBulkOperationStatusQueryResult = Apollo.QueryResult<GetShopifyBulkOperationStatusQuery, GetShopifyBulkOperationStatusQueryVariables>;
export const AddWebsiteDataSourceToDealDocument = gql`
    mutation addWebsiteDataSourceToDeal($hubspotDealId: ID!, $dataSourceParams: WebsiteDataSourceParamsInput!, $instructionMode: DatasourceInstructionMode) {
  addWebsiteDataSourceToDeal(
    hubspotDealId: $hubspotDealId
    dataSourceParams: $dataSourceParams
    instructionMode: $instructionMode
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type AddWebsiteDataSourceToDealMutationFn = Apollo.MutationFunction<AddWebsiteDataSourceToDealMutation, AddWebsiteDataSourceToDealMutationVariables>;

/**
 * __useAddWebsiteDataSourceToDealMutation__
 *
 * To run a mutation, you first call `useAddWebsiteDataSourceToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWebsiteDataSourceToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWebsiteDataSourceToDealMutation, { data, loading, error }] = useAddWebsiteDataSourceToDealMutation({
 *   variables: {
 *      hubspotDealId: // value for 'hubspotDealId'
 *      dataSourceParams: // value for 'dataSourceParams'
 *      instructionMode: // value for 'instructionMode'
 *   },
 * });
 */
export function useAddWebsiteDataSourceToDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddWebsiteDataSourceToDealMutation, AddWebsiteDataSourceToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWebsiteDataSourceToDealMutation, AddWebsiteDataSourceToDealMutationVariables>(AddWebsiteDataSourceToDealDocument, options);
      }
export type AddWebsiteDataSourceToDealMutationHookResult = ReturnType<typeof useAddWebsiteDataSourceToDealMutation>;
export type AddWebsiteDataSourceToDealMutationResult = Apollo.MutationResult<AddWebsiteDataSourceToDealMutation>;
export type AddWebsiteDataSourceToDealMutationOptions = Apollo.BaseMutationOptions<AddWebsiteDataSourceToDealMutation, AddWebsiteDataSourceToDealMutationVariables>;
export const UpdateDealItemsV2Document = gql`
    mutation UpdateDealItemsV2($dealId: ID!, $items: [DealItemUpdateInput!]!) {
  updateDealItemsV2(dealId: $dealId, items: $items) {
    ... on MutationUpdateDealItemsSuccess {
      updates {
        id
        changedFields
        previousHistoryId
        currentHistoryId
      }
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type UpdateDealItemsV2MutationFn = Apollo.MutationFunction<UpdateDealItemsV2Mutation, UpdateDealItemsV2MutationVariables>;

/**
 * __useUpdateDealItemsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateDealItemsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealItemsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealItemsV2Mutation, { data, loading, error }] = useUpdateDealItemsV2Mutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateDealItemsV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealItemsV2Mutation, UpdateDealItemsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealItemsV2Mutation, UpdateDealItemsV2MutationVariables>(UpdateDealItemsV2Document, options);
      }
export type UpdateDealItemsV2MutationHookResult = ReturnType<typeof useUpdateDealItemsV2Mutation>;
export type UpdateDealItemsV2MutationResult = Apollo.MutationResult<UpdateDealItemsV2Mutation>;
export type UpdateDealItemsV2MutationOptions = Apollo.BaseMutationOptions<UpdateDealItemsV2Mutation, UpdateDealItemsV2MutationVariables>;
export const RestoreDealItemsHistoryDocument = gql`
    mutation RestoreDealItemsHistory($dealId: ID!, $items: [RestoreDealItemInput!]!) {
  restoreDealItemsHistory(dealId: $dealId, items: $items) {
    ... on MutationSuccess {
      __typename
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type RestoreDealItemsHistoryMutationFn = Apollo.MutationFunction<RestoreDealItemsHistoryMutation, RestoreDealItemsHistoryMutationVariables>;

/**
 * __useRestoreDealItemsHistoryMutation__
 *
 * To run a mutation, you first call `useRestoreDealItemsHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDealItemsHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDealItemsHistoryMutation, { data, loading, error }] = useRestoreDealItemsHistoryMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useRestoreDealItemsHistoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreDealItemsHistoryMutation, RestoreDealItemsHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreDealItemsHistoryMutation, RestoreDealItemsHistoryMutationVariables>(RestoreDealItemsHistoryDocument, options);
      }
export type RestoreDealItemsHistoryMutationHookResult = ReturnType<typeof useRestoreDealItemsHistoryMutation>;
export type RestoreDealItemsHistoryMutationResult = Apollo.MutationResult<RestoreDealItemsHistoryMutation>;
export type RestoreDealItemsHistoryMutationOptions = Apollo.BaseMutationOptions<RestoreDealItemsHistoryMutation, RestoreDealItemsHistoryMutationVariables>;
export const MoveProductsToPositionDocument = gql`
    mutation MoveProductsToPosition($dealId: ID!, $productGroupKeys: [String!]!, $targetPosition: Int!) {
  moveProductsToPosition(
    dealId: $dealId
    productGroupKeys: $productGroupKeys
    targetPosition: $targetPosition
  ) {
    ... on MutationSuccess {
      __typename
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type MoveProductsToPositionMutationFn = Apollo.MutationFunction<MoveProductsToPositionMutation, MoveProductsToPositionMutationVariables>;

/**
 * __useMoveProductsToPositionMutation__
 *
 * To run a mutation, you first call `useMoveProductsToPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProductsToPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProductsToPositionMutation, { data, loading, error }] = useMoveProductsToPositionMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      productGroupKeys: // value for 'productGroupKeys'
 *      targetPosition: // value for 'targetPosition'
 *   },
 * });
 */
export function useMoveProductsToPositionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveProductsToPositionMutation, MoveProductsToPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveProductsToPositionMutation, MoveProductsToPositionMutationVariables>(MoveProductsToPositionDocument, options);
      }
export type MoveProductsToPositionMutationHookResult = ReturnType<typeof useMoveProductsToPositionMutation>;
export type MoveProductsToPositionMutationResult = Apollo.MutationResult<MoveProductsToPositionMutation>;
export type MoveProductsToPositionMutationOptions = Apollo.BaseMutationOptions<MoveProductsToPositionMutation, MoveProductsToPositionMutationVariables>;
export const ValidateDealSelectionDocument = gql`
    mutation ValidateDealSelection($dealId: ID!) {
  validateDealSelection(dealId: $dealId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ValidateDealSelectionMutationFn = Apollo.MutationFunction<ValidateDealSelectionMutation, ValidateDealSelectionMutationVariables>;

/**
 * __useValidateDealSelectionMutation__
 *
 * To run a mutation, you first call `useValidateDealSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDealSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDealSelectionMutation, { data, loading, error }] = useValidateDealSelectionMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useValidateDealSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateDealSelectionMutation, ValidateDealSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidateDealSelectionMutation, ValidateDealSelectionMutationVariables>(ValidateDealSelectionDocument, options);
      }
export type ValidateDealSelectionMutationHookResult = ReturnType<typeof useValidateDealSelectionMutation>;
export type ValidateDealSelectionMutationResult = Apollo.MutationResult<ValidateDealSelectionMutation>;
export type ValidateDealSelectionMutationOptions = Apollo.BaseMutationOptions<ValidateDealSelectionMutation, ValidateDealSelectionMutationVariables>;
export const CloseDealNegotiationDocument = gql`
    mutation CloseDealNegotiation($dealId: ID!) {
  closeDealNegotiation(dealId: $dealId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type CloseDealNegotiationMutationFn = Apollo.MutationFunction<CloseDealNegotiationMutation, CloseDealNegotiationMutationVariables>;

/**
 * __useCloseDealNegotiationMutation__
 *
 * To run a mutation, you first call `useCloseDealNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseDealNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeDealNegotiationMutation, { data, loading, error }] = useCloseDealNegotiationMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCloseDealNegotiationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloseDealNegotiationMutation, CloseDealNegotiationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloseDealNegotiationMutation, CloseDealNegotiationMutationVariables>(CloseDealNegotiationDocument, options);
      }
export type CloseDealNegotiationMutationHookResult = ReturnType<typeof useCloseDealNegotiationMutation>;
export type CloseDealNegotiationMutationResult = Apollo.MutationResult<CloseDealNegotiationMutation>;
export type CloseDealNegotiationMutationOptions = Apollo.BaseMutationOptions<CloseDealNegotiationMutation, CloseDealNegotiationMutationVariables>;
export const ReopenDealNegotiationDocument = gql`
    mutation ReopenDealNegotiation($dealId: ID!) {
  reopenDealNegotiation(dealId: $dealId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ReopenDealNegotiationMutationFn = Apollo.MutationFunction<ReopenDealNegotiationMutation, ReopenDealNegotiationMutationVariables>;

/**
 * __useReopenDealNegotiationMutation__
 *
 * To run a mutation, you first call `useReopenDealNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenDealNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenDealNegotiationMutation, { data, loading, error }] = useReopenDealNegotiationMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useReopenDealNegotiationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenDealNegotiationMutation, ReopenDealNegotiationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenDealNegotiationMutation, ReopenDealNegotiationMutationVariables>(ReopenDealNegotiationDocument, options);
      }
export type ReopenDealNegotiationMutationHookResult = ReturnType<typeof useReopenDealNegotiationMutation>;
export type ReopenDealNegotiationMutationResult = Apollo.MutationResult<ReopenDealNegotiationMutation>;
export type ReopenDealNegotiationMutationOptions = Apollo.BaseMutationOptions<ReopenDealNegotiationMutation, ReopenDealNegotiationMutationVariables>;
export const DealItemsUpdatedV3Document = gql`
    subscription DealItemsUpdatedV3($dealId: ID!) {
  dealItemsUpdatedV3(dealId: $dealId) {
    items {
      dealItemWithVersions {
        id
        activeVersion {
          id
          isSelected
          hasVatMargin
          name
          sku
          gtin
          shopifyVariantId
          options {
            name
            value
          }
          productCategory {
            productCategoryId
          }
          isBestSeller
          bestSellerQuantitySold
          eeePrice
          images
          listPrice
          discountedPrice
          chooseDiscount
          hasDescription
          choosePrice
          buyingPrice
          shippingPrice
          vatRate
          marginPercentage
          potentialSalesVolume
          stockQuantity
          sourceUrl
          madeIn
          productType
          couponExpirationDate
          couponTerms
          couponHowToUse
          validationErrors {
            ruleId
            message
            severity
          }
          updatingFields
          productGroupKey
          position
          historyId
        }
        lastBrandVersion {
          ...ValidatedDealItemFields
        }
        lastChooseVersion {
          ...ValidatedDealItemFields
        }
      }
      changedFields
    }
    fromAction {
      type
      datasourceId
    }
  }
}
    ${ValidatedDealItemFieldsFragmentDoc}`;

/**
 * __useDealItemsUpdatedV3Subscription__
 *
 * To run a query within a React component, call `useDealItemsUpdatedV3Subscription` and pass it any options that fit your needs.
 * When your component renders, `useDealItemsUpdatedV3Subscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealItemsUpdatedV3Subscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealItemsUpdatedV3Subscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<DealItemsUpdatedV3Subscription, DealItemsUpdatedV3SubscriptionVariables> & ({ variables: DealItemsUpdatedV3SubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<DealItemsUpdatedV3Subscription, DealItemsUpdatedV3SubscriptionVariables>(DealItemsUpdatedV3Document, options);
      }
export type DealItemsUpdatedV3SubscriptionHookResult = ReturnType<typeof useDealItemsUpdatedV3Subscription>;
export type DealItemsUpdatedV3SubscriptionResult = Apollo.SubscriptionResult<DealItemsUpdatedV3Subscription>;
export const DealUpdatedDocument = gql`
    subscription DealUpdated($dealId: ID!) {
  dealUpdated(dealId: $dealId) {
    id
    hubspotDealId
    brandId
    activeVersionId
    hubspotInfos {
      dealName
      startDate
      store
      dealManager {
        id
        name
        photoUrl
        email
      }
    }
    state
    editionMode
    dealShippingPolicy {
      id
      freeShippingMinimumOrderAmount
      deliveryOfferedNumberOfDays
      basicFrPickupPointDeliveryPrice
      pickupPointNetwork
    }
    dataSources {
      ... on WebsiteDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        cms
        websiteUrl
        productUrl
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
      }
      ... on CSVDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        source
        signedUrl
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
      }
      ... on PreviousCampaignDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        brandId
        saleId
        status
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
        source
      }
      ... on ShopifyCatalogDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
        source
      }
      ... on ExternalCatalogDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        status
        createdAt
        updatedAt
        author {
          id
          name
          email
          actorRole
        }
        errors {
          step
          code
          message
        }
        source
      }
    }
    createdAt
    updatedAt
  }
}
    ${DataSourceInstructionsFieldsFragmentDoc}`;

/**
 * __useDealUpdatedSubscription__
 *
 * To run a query within a React component, call `useDealUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDealUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealUpdatedSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealUpdatedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<DealUpdatedSubscription, DealUpdatedSubscriptionVariables> & ({ variables: DealUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<DealUpdatedSubscription, DealUpdatedSubscriptionVariables>(DealUpdatedDocument, options);
      }
export type DealUpdatedSubscriptionHookResult = ReturnType<typeof useDealUpdatedSubscription>;
export type DealUpdatedSubscriptionResult = Apollo.SubscriptionResult<DealUpdatedSubscription>;
export const DealVersionsDocument = gql`
    query DealVersions($dealId: ID!) {
  dealVersions(dealId: $dealId) {
    id
    dealId
    versionNumber
    status
    isValidatedByBrand
    isValidatedByChoose
    createdAt
    updatedAt
    createdBy {
      id
      name
      email
      actorRole
    }
  }
}
    `;

/**
 * __useDealVersionsQuery__
 *
 * To run a query within a React component, call `useDealVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealVersionsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealVersionsQuery, DealVersionsQueryVariables> & ({ variables: DealVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealVersionsQuery, DealVersionsQueryVariables>(DealVersionsDocument, options);
      }
export function useDealVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealVersionsQuery, DealVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealVersionsQuery, DealVersionsQueryVariables>(DealVersionsDocument, options);
        }
export function useDealVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DealVersionsQuery, DealVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DealVersionsQuery, DealVersionsQueryVariables>(DealVersionsDocument, options);
        }
export type DealVersionsQueryHookResult = ReturnType<typeof useDealVersionsQuery>;
export type DealVersionsLazyQueryHookResult = ReturnType<typeof useDealVersionsLazyQuery>;
export type DealVersionsSuspenseQueryHookResult = ReturnType<typeof useDealVersionsSuspenseQuery>;
export type DealVersionsQueryResult = Apollo.QueryResult<DealVersionsQuery, DealVersionsQueryVariables>;
export const CreateDealItemDocument = gql`
    mutation CreateDealItem($dealId: ID!, $item: DealItemCreateInput!) {
  createDealItem(dealId: $dealId, item: $item) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type CreateDealItemMutationFn = Apollo.MutationFunction<CreateDealItemMutation, CreateDealItemMutationVariables>;

/**
 * __useCreateDealItemMutation__
 *
 * To run a mutation, you first call `useCreateDealItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealItemMutation, { data, loading, error }] = useCreateDealItemMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      item: // value for 'item'
 *   },
 * });
 */
export function useCreateDealItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealItemMutation, CreateDealItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDealItemMutation, CreateDealItemMutationVariables>(CreateDealItemDocument, options);
      }
export type CreateDealItemMutationHookResult = ReturnType<typeof useCreateDealItemMutation>;
export type CreateDealItemMutationResult = Apollo.MutationResult<CreateDealItemMutation>;
export type CreateDealItemMutationOptions = Apollo.BaseMutationOptions<CreateDealItemMutation, CreateDealItemMutationVariables>;
export const ExportDealSelectionDocument = gql`
    mutation ExportDealSelection($dealId: ID!, $template: ExportTemplate!, $language: LanguageIso6391!) {
  exportDealSelection(dealId: $dealId, template: $template, language: $language) {
    __typename
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ExportDealSelectionMutationFn = Apollo.MutationFunction<ExportDealSelectionMutation, ExportDealSelectionMutationVariables>;

/**
 * __useExportDealSelectionMutation__
 *
 * To run a mutation, you first call `useExportDealSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDealSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDealSelectionMutation, { data, loading, error }] = useExportDealSelectionMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      template: // value for 'template'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useExportDealSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportDealSelectionMutation, ExportDealSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportDealSelectionMutation, ExportDealSelectionMutationVariables>(ExportDealSelectionDocument, options);
      }
export type ExportDealSelectionMutationHookResult = ReturnType<typeof useExportDealSelectionMutation>;
export type ExportDealSelectionMutationResult = Apollo.MutationResult<ExportDealSelectionMutation>;
export type ExportDealSelectionMutationOptions = Apollo.BaseMutationOptions<ExportDealSelectionMutation, ExportDealSelectionMutationVariables>;
export const ExportDealForAnalyseDocument = gql`
    mutation ExportDealForAnalyse($dealId: ID!, $language: LanguageIso6391, $prompt: String) {
  exportDealForAnalyse(dealId: $dealId, language: $language, prompt: $prompt) {
    __typename
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ExportDealForAnalyseMutationFn = Apollo.MutationFunction<ExportDealForAnalyseMutation, ExportDealForAnalyseMutationVariables>;

/**
 * __useExportDealForAnalyseMutation__
 *
 * To run a mutation, you first call `useExportDealForAnalyseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDealForAnalyseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDealForAnalyseMutation, { data, loading, error }] = useExportDealForAnalyseMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      language: // value for 'language'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useExportDealForAnalyseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportDealForAnalyseMutation, ExportDealForAnalyseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportDealForAnalyseMutation, ExportDealForAnalyseMutationVariables>(ExportDealForAnalyseDocument, options);
      }
export type ExportDealForAnalyseMutationHookResult = ReturnType<typeof useExportDealForAnalyseMutation>;
export type ExportDealForAnalyseMutationResult = Apollo.MutationResult<ExportDealForAnalyseMutation>;
export type ExportDealForAnalyseMutationOptions = Apollo.BaseMutationOptions<ExportDealForAnalyseMutation, ExportDealForAnalyseMutationVariables>;
export const WatchDealSelectionExportsDocument = gql`
    subscription WatchDealSelectionExports($dealId: ID!) {
  dealSelectionExportsUpdated(dealId: $dealId) {
    id
    status
    dealId
    downloadUrlAvailable
    createdAt
    updatedAt
    errors {
      step
      code
      operation
      documentTitle
      fileId
    }
  }
}
    `;

/**
 * __useWatchDealSelectionExportsSubscription__
 *
 * To run a query within a React component, call `useWatchDealSelectionExportsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDealSelectionExportsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDealSelectionExportsSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useWatchDealSelectionExportsSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<WatchDealSelectionExportsSubscription, WatchDealSelectionExportsSubscriptionVariables> & ({ variables: WatchDealSelectionExportsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<WatchDealSelectionExportsSubscription, WatchDealSelectionExportsSubscriptionVariables>(WatchDealSelectionExportsDocument, options);
      }
export type WatchDealSelectionExportsSubscriptionHookResult = ReturnType<typeof useWatchDealSelectionExportsSubscription>;
export type WatchDealSelectionExportsSubscriptionResult = Apollo.SubscriptionResult<WatchDealSelectionExportsSubscription>;
export const GetDealSelectionExportDownloadUrlDocument = gql`
    query GetDealSelectionExportDownloadUrl($exportId: ID!) {
  dealSelectionExportDownloadUrl(exportId: $exportId)
}
    `;

/**
 * __useGetDealSelectionExportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDealSelectionExportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealSelectionExportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealSelectionExportDownloadUrlQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetDealSelectionExportDownloadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables> & ({ variables: GetDealSelectionExportDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables>(GetDealSelectionExportDownloadUrlDocument, options);
      }
export function useGetDealSelectionExportDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables>(GetDealSelectionExportDownloadUrlDocument, options);
        }
export function useGetDealSelectionExportDownloadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables>(GetDealSelectionExportDownloadUrlDocument, options);
        }
export type GetDealSelectionExportDownloadUrlQueryHookResult = ReturnType<typeof useGetDealSelectionExportDownloadUrlQuery>;
export type GetDealSelectionExportDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDealSelectionExportDownloadUrlLazyQuery>;
export type GetDealSelectionExportDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDealSelectionExportDownloadUrlSuspenseQuery>;
export type GetDealSelectionExportDownloadUrlQueryResult = Apollo.QueryResult<GetDealSelectionExportDownloadUrlQuery, GetDealSelectionExportDownloadUrlQueryVariables>;
export const GetAllCountryLabelsDocument = gql`
    query GetAllCountryLabels {
  allCountryLabels {
    code
    fr
    en
  }
}
    `;

/**
 * __useGetAllCountryLabelsQuery__
 *
 * To run a query within a React component, call `useGetAllCountryLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountryLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountryLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountryLabelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>(GetAllCountryLabelsDocument, options);
      }
export function useGetAllCountryLabelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>(GetAllCountryLabelsDocument, options);
        }
export function useGetAllCountryLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>(GetAllCountryLabelsDocument, options);
        }
export type GetAllCountryLabelsQueryHookResult = ReturnType<typeof useGetAllCountryLabelsQuery>;
export type GetAllCountryLabelsLazyQueryHookResult = ReturnType<typeof useGetAllCountryLabelsLazyQuery>;
export type GetAllCountryLabelsSuspenseQueryHookResult = ReturnType<typeof useGetAllCountryLabelsSuspenseQuery>;
export type GetAllCountryLabelsQueryResult = Apollo.QueryResult<GetAllCountryLabelsQuery, GetAllCountryLabelsQueryVariables>;
export const GetTopCountryLabelsDocument = gql`
    query GetTopCountryLabels($store: StoreRegion!) {
  topCountryLabels(store: $store) {
    code
    fr
    en
  }
}
    `;

/**
 * __useGetTopCountryLabelsQuery__
 *
 * To run a query within a React component, call `useGetTopCountryLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopCountryLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopCountryLabelsQuery({
 *   variables: {
 *      store: // value for 'store'
 *   },
 * });
 */
export function useGetTopCountryLabelsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables> & ({ variables: GetTopCountryLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables>(GetTopCountryLabelsDocument, options);
      }
export function useGetTopCountryLabelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables>(GetTopCountryLabelsDocument, options);
        }
export function useGetTopCountryLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables>(GetTopCountryLabelsDocument, options);
        }
export type GetTopCountryLabelsQueryHookResult = ReturnType<typeof useGetTopCountryLabelsQuery>;
export type GetTopCountryLabelsLazyQueryHookResult = ReturnType<typeof useGetTopCountryLabelsLazyQuery>;
export type GetTopCountryLabelsSuspenseQueryHookResult = ReturnType<typeof useGetTopCountryLabelsSuspenseQuery>;
export type GetTopCountryLabelsQueryResult = Apollo.QueryResult<GetTopCountryLabelsQuery, GetTopCountryLabelsQueryVariables>;
export const GetCsvTemplateDocument = gql`
    mutation GetCsvTemplate($templateId: CsvTemplate!, $language: LanguageIso6391!) {
  exportDealCsvTemplate(templateId: $templateId, language: $language) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type GetCsvTemplateMutationFn = Apollo.MutationFunction<GetCsvTemplateMutation, GetCsvTemplateMutationVariables>;

/**
 * __useGetCsvTemplateMutation__
 *
 * To run a mutation, you first call `useGetCsvTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCsvTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCsvTemplateMutation, { data, loading, error }] = useGetCsvTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetCsvTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetCsvTemplateMutation, GetCsvTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetCsvTemplateMutation, GetCsvTemplateMutationVariables>(GetCsvTemplateDocument, options);
      }
export type GetCsvTemplateMutationHookResult = ReturnType<typeof useGetCsvTemplateMutation>;
export type GetCsvTemplateMutationResult = Apollo.MutationResult<GetCsvTemplateMutation>;
export type GetCsvTemplateMutationOptions = Apollo.BaseMutationOptions<GetCsvTemplateMutation, GetCsvTemplateMutationVariables>;
export const AddCsvDataSourceToDealDocument = gql`
    mutation AddCsvDataSourceToDeal($dealId: ID!, $instructionMode: DatasourceInstructionMode, $anchorKey: DealItemAnchorKey, $eMerchCustomFieldsHeaders: [String!]) {
  addCsvDataSourceToDeal(
    dealId: $dealId
    instructionMode: $instructionMode
    anchorKey: $anchorKey
    eMerchCustomFieldsHeaders: $eMerchCustomFieldsHeaders
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type AddCsvDataSourceToDealMutationFn = Apollo.MutationFunction<AddCsvDataSourceToDealMutation, AddCsvDataSourceToDealMutationVariables>;

/**
 * __useAddCsvDataSourceToDealMutation__
 *
 * To run a mutation, you first call `useAddCsvDataSourceToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCsvDataSourceToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCsvDataSourceToDealMutation, { data, loading, error }] = useAddCsvDataSourceToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      instructionMode: // value for 'instructionMode'
 *      anchorKey: // value for 'anchorKey'
 *      eMerchCustomFieldsHeaders: // value for 'eMerchCustomFieldsHeaders'
 *   },
 * });
 */
export function useAddCsvDataSourceToDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCsvDataSourceToDealMutation, AddCsvDataSourceToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddCsvDataSourceToDealMutation, AddCsvDataSourceToDealMutationVariables>(AddCsvDataSourceToDealDocument, options);
      }
export type AddCsvDataSourceToDealMutationHookResult = ReturnType<typeof useAddCsvDataSourceToDealMutation>;
export type AddCsvDataSourceToDealMutationResult = Apollo.MutationResult<AddCsvDataSourceToDealMutation>;
export type AddCsvDataSourceToDealMutationOptions = Apollo.BaseMutationOptions<AddCsvDataSourceToDealMutation, AddCsvDataSourceToDealMutationVariables>;
export const AddCouponCodesCsvDataSourceToDealDocument = gql`
    mutation AddCouponCodesCsvDataSourceToDeal($dealId: ID!) {
  addCouponCodesCsvDataSourceToDeal(dealId: $dealId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type AddCouponCodesCsvDataSourceToDealMutationFn = Apollo.MutationFunction<AddCouponCodesCsvDataSourceToDealMutation, AddCouponCodesCsvDataSourceToDealMutationVariables>;

/**
 * __useAddCouponCodesCsvDataSourceToDealMutation__
 *
 * To run a mutation, you first call `useAddCouponCodesCsvDataSourceToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCouponCodesCsvDataSourceToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCouponCodesCsvDataSourceToDealMutation, { data, loading, error }] = useAddCouponCodesCsvDataSourceToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useAddCouponCodesCsvDataSourceToDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCouponCodesCsvDataSourceToDealMutation, AddCouponCodesCsvDataSourceToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddCouponCodesCsvDataSourceToDealMutation, AddCouponCodesCsvDataSourceToDealMutationVariables>(AddCouponCodesCsvDataSourceToDealDocument, options);
      }
export type AddCouponCodesCsvDataSourceToDealMutationHookResult = ReturnType<typeof useAddCouponCodesCsvDataSourceToDealMutation>;
export type AddCouponCodesCsvDataSourceToDealMutationResult = Apollo.MutationResult<AddCouponCodesCsvDataSourceToDealMutation>;
export type AddCouponCodesCsvDataSourceToDealMutationOptions = Apollo.BaseMutationOptions<AddCouponCodesCsvDataSourceToDealMutation, AddCouponCodesCsvDataSourceToDealMutationVariables>;
export const GetSignedUrlDocument = gql`
    query GetSignedUrl($dealId: ID!) {
  deal(dealId: $dealId) {
    dataSources {
      ... on CSVDataSource {
        id
        instructions {
          ...DataSourceInstructionsFields
        }
        signedUrl
      }
    }
  }
}
    ${DataSourceInstructionsFieldsFragmentDoc}`;

/**
 * __useGetSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUrlQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetSignedUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSignedUrlQuery, GetSignedUrlQueryVariables> & ({ variables: GetSignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, options);
      }
export function useGetSignedUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSignedUrlQuery, GetSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, options);
        }
export function useGetSignedUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSignedUrlQuery, GetSignedUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, options);
        }
export type GetSignedUrlQueryHookResult = ReturnType<typeof useGetSignedUrlQuery>;
export type GetSignedUrlLazyQueryHookResult = ReturnType<typeof useGetSignedUrlLazyQuery>;
export type GetSignedUrlSuspenseQueryHookResult = ReturnType<typeof useGetSignedUrlSuspenseQuery>;
export type GetSignedUrlQueryResult = Apollo.QueryResult<GetSignedUrlQuery, GetSignedUrlQueryVariables>;
export const MarkDataSourceAsImportedDocument = gql`
    mutation MarkDataSourceAsImported($dealId: ID!, $dataSourceId: ID!) {
  markDataSourceAsImported(dealId: $dealId, dataSourceId: $dataSourceId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type MarkDataSourceAsImportedMutationFn = Apollo.MutationFunction<MarkDataSourceAsImportedMutation, MarkDataSourceAsImportedMutationVariables>;

/**
 * __useMarkDataSourceAsImportedMutation__
 *
 * To run a mutation, you first call `useMarkDataSourceAsImportedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDataSourceAsImportedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDataSourceAsImportedMutation, { data, loading, error }] = useMarkDataSourceAsImportedMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dataSourceId: // value for 'dataSourceId'
 *   },
 * });
 */
export function useMarkDataSourceAsImportedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkDataSourceAsImportedMutation, MarkDataSourceAsImportedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkDataSourceAsImportedMutation, MarkDataSourceAsImportedMutationVariables>(MarkDataSourceAsImportedDocument, options);
      }
export type MarkDataSourceAsImportedMutationHookResult = ReturnType<typeof useMarkDataSourceAsImportedMutation>;
export type MarkDataSourceAsImportedMutationResult = Apollo.MutationResult<MarkDataSourceAsImportedMutation>;
export type MarkDataSourceAsImportedMutationOptions = Apollo.BaseMutationOptions<MarkDataSourceAsImportedMutation, MarkDataSourceAsImportedMutationVariables>;
export const EditDealShippingPolicyDocument = gql`
    mutation EditDealShippingPolicy($dealId: ID!, $shippingPolicy: DealShippingPolicyInput!) {
  editDealShippingPolicy(dealId: $dealId, shippingPolicy: $shippingPolicy) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type EditDealShippingPolicyMutationFn = Apollo.MutationFunction<EditDealShippingPolicyMutation, EditDealShippingPolicyMutationVariables>;

/**
 * __useEditDealShippingPolicyMutation__
 *
 * To run a mutation, you first call `useEditDealShippingPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDealShippingPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDealShippingPolicyMutation, { data, loading, error }] = useEditDealShippingPolicyMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      shippingPolicy: // value for 'shippingPolicy'
 *   },
 * });
 */
export function useEditDealShippingPolicyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditDealShippingPolicyMutation, EditDealShippingPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditDealShippingPolicyMutation, EditDealShippingPolicyMutationVariables>(EditDealShippingPolicyDocument, options);
      }
export type EditDealShippingPolicyMutationHookResult = ReturnType<typeof useEditDealShippingPolicyMutation>;
export type EditDealShippingPolicyMutationResult = Apollo.MutationResult<EditDealShippingPolicyMutation>;
export type EditDealShippingPolicyMutationOptions = Apollo.BaseMutationOptions<EditDealShippingPolicyMutation, EditDealShippingPolicyMutationVariables>;
export const DeleteDealItemsDocument = gql`
    mutation DeleteDealItems($dealId: ID!, $dealItemsIds: [ID!]!, $password: String!) {
  deleteDealItems(
    dealId: $dealId
    dealItemsIds: $dealItemsIds
    password: $password
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type DeleteDealItemsMutationFn = Apollo.MutationFunction<DeleteDealItemsMutation, DeleteDealItemsMutationVariables>;

/**
 * __useDeleteDealItemsMutation__
 *
 * To run a mutation, you first call `useDeleteDealItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealItemsMutation, { data, loading, error }] = useDeleteDealItemsMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealItemsIds: // value for 'dealItemsIds'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDeleteDealItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDealItemsMutation, DeleteDealItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDealItemsMutation, DeleteDealItemsMutationVariables>(DeleteDealItemsDocument, options);
      }
export type DeleteDealItemsMutationHookResult = ReturnType<typeof useDeleteDealItemsMutation>;
export type DeleteDealItemsMutationResult = Apollo.MutationResult<DeleteDealItemsMutation>;
export type DeleteDealItemsMutationOptions = Apollo.BaseMutationOptions<DeleteDealItemsMutation, DeleteDealItemsMutationVariables>;
export const ComputeChoosePriceDocument = gql`
    mutation ComputeChoosePrice($dealId: ID!, $itemIds: [ID!]!, $strategy: PsychologicalPriceStrategy!) {
  computeChoosePriceV2(dealId: $dealId, itemIds: $itemIds, strategy: $strategy) {
    ... on MutationUpdateDealItemsSuccess {
      updates {
        id
        changedFields
        previousHistoryId
        currentHistoryId
      }
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ComputeChoosePriceMutationFn = Apollo.MutationFunction<ComputeChoosePriceMutation, ComputeChoosePriceMutationVariables>;

/**
 * __useComputeChoosePriceMutation__
 *
 * To run a mutation, you first call `useComputeChoosePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeChoosePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeChoosePriceMutation, { data, loading, error }] = useComputeChoosePriceMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      itemIds: // value for 'itemIds'
 *      strategy: // value for 'strategy'
 *   },
 * });
 */
export function useComputeChoosePriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ComputeChoosePriceMutation, ComputeChoosePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ComputeChoosePriceMutation, ComputeChoosePriceMutationVariables>(ComputeChoosePriceDocument, options);
      }
export type ComputeChoosePriceMutationHookResult = ReturnType<typeof useComputeChoosePriceMutation>;
export type ComputeChoosePriceMutationResult = Apollo.MutationResult<ComputeChoosePriceMutation>;
export type ComputeChoosePriceMutationOptions = Apollo.BaseMutationOptions<ComputeChoosePriceMutation, ComputeChoosePriceMutationVariables>;
export const CategoryTreeDocument = gql`
    query CategoryTree($language: LanguageIso6391) {
  categoryTree(language: $language) {
    id
    label
    tva
    notReturnable
    subCategories {
      id
      label
      tva
      notReturnable
      subCategories {
        id
        label
        tva
        notReturnable
        subCategories {
          id
          label
          tva
          notReturnable
          subCategories {
            id
            label
            tva
            notReturnable
            subCategories {
              id
              label
              tva
              notReturnable
              subCategories {
                id
                label
                tva
                notReturnable
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCategoryTreeQuery__
 *
 * To run a query within a React component, call `useCategoryTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryTreeQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCategoryTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CategoryTreeQuery, CategoryTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CategoryTreeQuery, CategoryTreeQueryVariables>(CategoryTreeDocument, options);
      }
export function useCategoryTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoryTreeQuery, CategoryTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CategoryTreeQuery, CategoryTreeQueryVariables>(CategoryTreeDocument, options);
        }
export function useCategoryTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CategoryTreeQuery, CategoryTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CategoryTreeQuery, CategoryTreeQueryVariables>(CategoryTreeDocument, options);
        }
export type CategoryTreeQueryHookResult = ReturnType<typeof useCategoryTreeQuery>;
export type CategoryTreeLazyQueryHookResult = ReturnType<typeof useCategoryTreeLazyQuery>;
export type CategoryTreeSuspenseQueryHookResult = ReturnType<typeof useCategoryTreeSuspenseQuery>;
export type CategoryTreeQueryResult = Apollo.QueryResult<CategoryTreeQuery, CategoryTreeQueryVariables>;
export const RestoreDealVersionDocument = gql`
    mutation RestoreDealVersion($dealId: ID!, $versionId: ID!) {
  restoreDealVersion(dealId: $dealId, versionId: $versionId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type RestoreDealVersionMutationFn = Apollo.MutationFunction<RestoreDealVersionMutation, RestoreDealVersionMutationVariables>;

/**
 * __useRestoreDealVersionMutation__
 *
 * To run a mutation, you first call `useRestoreDealVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDealVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDealVersionMutation, { data, loading, error }] = useRestoreDealVersionMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useRestoreDealVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreDealVersionMutation, RestoreDealVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreDealVersionMutation, RestoreDealVersionMutationVariables>(RestoreDealVersionDocument, options);
      }
export type RestoreDealVersionMutationHookResult = ReturnType<typeof useRestoreDealVersionMutation>;
export type RestoreDealVersionMutationResult = Apollo.MutationResult<RestoreDealVersionMutation>;
export type RestoreDealVersionMutationOptions = Apollo.BaseMutationOptions<RestoreDealVersionMutation, RestoreDealVersionMutationVariables>;
export const AddPreviousCampaignToDealDocument = gql`
    mutation AddPreviousCampaignToDeal($dealId: ID!, $saleId: ID!, $instructionMode: DatasourceInstructionMode) {
  addPreviousCampaignToDeal(
    dealId: $dealId
    saleId: $saleId
    instructionMode: $instructionMode
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type AddPreviousCampaignToDealMutationFn = Apollo.MutationFunction<AddPreviousCampaignToDealMutation, AddPreviousCampaignToDealMutationVariables>;

/**
 * __useAddPreviousCampaignToDealMutation__
 *
 * To run a mutation, you first call `useAddPreviousCampaignToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPreviousCampaignToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPreviousCampaignToDealMutation, { data, loading, error }] = useAddPreviousCampaignToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      saleId: // value for 'saleId'
 *      instructionMode: // value for 'instructionMode'
 *   },
 * });
 */
export function useAddPreviousCampaignToDealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPreviousCampaignToDealMutation, AddPreviousCampaignToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPreviousCampaignToDealMutation, AddPreviousCampaignToDealMutationVariables>(AddPreviousCampaignToDealDocument, options);
      }
export type AddPreviousCampaignToDealMutationHookResult = ReturnType<typeof useAddPreviousCampaignToDealMutation>;
export type AddPreviousCampaignToDealMutationResult = Apollo.MutationResult<AddPreviousCampaignToDealMutation>;
export type AddPreviousCampaignToDealMutationOptions = Apollo.BaseMutationOptions<AddPreviousCampaignToDealMutation, AddPreviousCampaignToDealMutationVariables>;
export const GetSaleProductsPreviewDocument = gql`
    query GetSaleProductsPreview($brandId: ID!, $saleId: ID!) {
  saleProductsPreview(brandId: $brandId, saleId: $saleId) {
    name
    image
    price
    stock
    saleId
  }
}
    `;

/**
 * __useGetSaleProductsPreviewQuery__
 *
 * To run a query within a React component, call `useGetSaleProductsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleProductsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleProductsPreviewQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useGetSaleProductsPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables> & ({ variables: GetSaleProductsPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables>(GetSaleProductsPreviewDocument, options);
      }
export function useGetSaleProductsPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables>(GetSaleProductsPreviewDocument, options);
        }
export function useGetSaleProductsPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables>(GetSaleProductsPreviewDocument, options);
        }
export type GetSaleProductsPreviewQueryHookResult = ReturnType<typeof useGetSaleProductsPreviewQuery>;
export type GetSaleProductsPreviewLazyQueryHookResult = ReturnType<typeof useGetSaleProductsPreviewLazyQuery>;
export type GetSaleProductsPreviewSuspenseQueryHookResult = ReturnType<typeof useGetSaleProductsPreviewSuspenseQuery>;
export type GetSaleProductsPreviewQueryResult = Apollo.QueryResult<GetSaleProductsPreviewQuery, GetSaleProductsPreviewQueryVariables>;
export const GetDealKpisDocument = gql`
    query GetDealKpis($dealId: ID!, $compareToSaleId: ID) {
  dealKpis(dealId: $dealId, compareToSaleId: $compareToSaleId) {
    currentDealKpis {
      avgChoosePrice
      avgDiscount
      avgMargin
      productsCount
      totalPotential
      totalStock
    }
    previousCampaignKpis {
      avgChoosePrice
      avgDiscount
      avgMargin
      productsCount
      totalPotential
      totalStock
    }
    evolutionInsightsV2 {
      campaignItemsWithEvolution {
        dealItemId
        listPrice
        chooseDiscount
        choosePrice
        stockQuantity
      }
      discountReductions
      discountIncreases
      stockReductions
      addedProducts
    }
  }
}
    `;

/**
 * __useGetDealKpisQuery__
 *
 * To run a query within a React component, call `useGetDealKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealKpisQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      compareToSaleId: // value for 'compareToSaleId'
 *   },
 * });
 */
export function useGetDealKpisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDealKpisQuery, GetDealKpisQueryVariables> & ({ variables: GetDealKpisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealKpisQuery, GetDealKpisQueryVariables>(GetDealKpisDocument, options);
      }
export function useGetDealKpisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealKpisQuery, GetDealKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealKpisQuery, GetDealKpisQueryVariables>(GetDealKpisDocument, options);
        }
export function useGetDealKpisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealKpisQuery, GetDealKpisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealKpisQuery, GetDealKpisQueryVariables>(GetDealKpisDocument, options);
        }
export type GetDealKpisQueryHookResult = ReturnType<typeof useGetDealKpisQuery>;
export type GetDealKpisLazyQueryHookResult = ReturnType<typeof useGetDealKpisLazyQuery>;
export type GetDealKpisSuspenseQueryHookResult = ReturnType<typeof useGetDealKpisSuspenseQuery>;
export type GetDealKpisQueryResult = Apollo.QueryResult<GetDealKpisQuery, GetDealKpisQueryVariables>;
export const SyncImagesDocument = gql`
    mutation SyncImages($dealId: ID!, $dealItemsIds: [ID!]!) {
  syncImages(dealId: $dealId, dealItemsIds: $dealItemsIds) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type SyncImagesMutationFn = Apollo.MutationFunction<SyncImagesMutation, SyncImagesMutationVariables>;

/**
 * __useSyncImagesMutation__
 *
 * To run a mutation, you first call `useSyncImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncImagesMutation, { data, loading, error }] = useSyncImagesMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealItemsIds: // value for 'dealItemsIds'
 *   },
 * });
 */
export function useSyncImagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncImagesMutation, SyncImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncImagesMutation, SyncImagesMutationVariables>(SyncImagesDocument, options);
      }
export type SyncImagesMutationHookResult = ReturnType<typeof useSyncImagesMutation>;
export type SyncImagesMutationResult = Apollo.MutationResult<SyncImagesMutation>;
export type SyncImagesMutationOptions = Apollo.BaseMutationOptions<SyncImagesMutation, SyncImagesMutationVariables>;
export const TriggerCategorizeDealItemsDocument = gql`
    mutation TriggerCategorizeDealItems($dealId: ID!, $dealItemsIds: [ID!]!, $forceRecategorize: Boolean!) {
  triggerCategorizeDealItems(
    dealId: $dealId
    dealItemsIds: $dealItemsIds
    forceRecategorize: $forceRecategorize
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type TriggerCategorizeDealItemsMutationFn = Apollo.MutationFunction<TriggerCategorizeDealItemsMutation, TriggerCategorizeDealItemsMutationVariables>;

/**
 * __useTriggerCategorizeDealItemsMutation__
 *
 * To run a mutation, you first call `useTriggerCategorizeDealItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCategorizeDealItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCategorizeDealItemsMutation, { data, loading, error }] = useTriggerCategorizeDealItemsMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealItemsIds: // value for 'dealItemsIds'
 *      forceRecategorize: // value for 'forceRecategorize'
 *   },
 * });
 */
export function useTriggerCategorizeDealItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerCategorizeDealItemsMutation, TriggerCategorizeDealItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerCategorizeDealItemsMutation, TriggerCategorizeDealItemsMutationVariables>(TriggerCategorizeDealItemsDocument, options);
      }
export type TriggerCategorizeDealItemsMutationHookResult = ReturnType<typeof useTriggerCategorizeDealItemsMutation>;
export type TriggerCategorizeDealItemsMutationResult = Apollo.MutationResult<TriggerCategorizeDealItemsMutation>;
export type TriggerCategorizeDealItemsMutationOptions = Apollo.BaseMutationOptions<TriggerCategorizeDealItemsMutation, TriggerCategorizeDealItemsMutationVariables>;
export const ExtractColorFromImagesDocument = gql`
    mutation ExtractColorFromImages($dealId: ID!, $dealItemsIds: [ID!]!) {
  extractColorFromImages(dealId: $dealId, dealItemsIds: $dealItemsIds) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ExtractColorFromImagesMutationFn = Apollo.MutationFunction<ExtractColorFromImagesMutation, ExtractColorFromImagesMutationVariables>;

/**
 * __useExtractColorFromImagesMutation__
 *
 * To run a mutation, you first call `useExtractColorFromImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractColorFromImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractColorFromImagesMutation, { data, loading, error }] = useExtractColorFromImagesMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealItemsIds: // value for 'dealItemsIds'
 *   },
 * });
 */
export function useExtractColorFromImagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExtractColorFromImagesMutation, ExtractColorFromImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExtractColorFromImagesMutation, ExtractColorFromImagesMutationVariables>(ExtractColorFromImagesDocument, options);
      }
export type ExtractColorFromImagesMutationHookResult = ReturnType<typeof useExtractColorFromImagesMutation>;
export type ExtractColorFromImagesMutationResult = Apollo.MutationResult<ExtractColorFromImagesMutation>;
export type ExtractColorFromImagesMutationOptions = Apollo.BaseMutationOptions<ExtractColorFromImagesMutation, ExtractColorFromImagesMutationVariables>;
export const UpdateDealSetupNoteDocument = gql`
    mutation UpdateDealSetupNote($dealId: ID!, $setupNote: String!) {
  updateDealSetupNote(dealId: $dealId, setupNote: $setupNote) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type UpdateDealSetupNoteMutationFn = Apollo.MutationFunction<UpdateDealSetupNoteMutation, UpdateDealSetupNoteMutationVariables>;

/**
 * __useUpdateDealSetupNoteMutation__
 *
 * To run a mutation, you first call `useUpdateDealSetupNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealSetupNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealSetupNoteMutation, { data, loading, error }] = useUpdateDealSetupNoteMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      setupNote: // value for 'setupNote'
 *   },
 * });
 */
export function useUpdateDealSetupNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealSetupNoteMutation, UpdateDealSetupNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealSetupNoteMutation, UpdateDealSetupNoteMutationVariables>(UpdateDealSetupNoteDocument, options);
      }
export type UpdateDealSetupNoteMutationHookResult = ReturnType<typeof useUpdateDealSetupNoteMutation>;
export type UpdateDealSetupNoteMutationResult = Apollo.MutationResult<UpdateDealSetupNoteMutation>;
export type UpdateDealSetupNoteMutationOptions = Apollo.BaseMutationOptions<UpdateDealSetupNoteMutation, UpdateDealSetupNoteMutationVariables>;
export const UpdateDealGoogleDriveImagesUrlDocument = gql`
    mutation UpdateDealGoogleDriveImagesUrl($dealId: ID!, $googleDriveImagesUrl: String) {
  updateDealGoogleDriveImagesUrl(
    dealId: $dealId
    googleDriveImagesUrl: $googleDriveImagesUrl
  ) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type UpdateDealGoogleDriveImagesUrlMutationFn = Apollo.MutationFunction<UpdateDealGoogleDriveImagesUrlMutation, UpdateDealGoogleDriveImagesUrlMutationVariables>;

/**
 * __useUpdateDealGoogleDriveImagesUrlMutation__
 *
 * To run a mutation, you first call `useUpdateDealGoogleDriveImagesUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealGoogleDriveImagesUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealGoogleDriveImagesUrlMutation, { data, loading, error }] = useUpdateDealGoogleDriveImagesUrlMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      googleDriveImagesUrl: // value for 'googleDriveImagesUrl'
 *   },
 * });
 */
export function useUpdateDealGoogleDriveImagesUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealGoogleDriveImagesUrlMutation, UpdateDealGoogleDriveImagesUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealGoogleDriveImagesUrlMutation, UpdateDealGoogleDriveImagesUrlMutationVariables>(UpdateDealGoogleDriveImagesUrlDocument, options);
      }
export type UpdateDealGoogleDriveImagesUrlMutationHookResult = ReturnType<typeof useUpdateDealGoogleDriveImagesUrlMutation>;
export type UpdateDealGoogleDriveImagesUrlMutationResult = Apollo.MutationResult<UpdateDealGoogleDriveImagesUrlMutation>;
export type UpdateDealGoogleDriveImagesUrlMutationOptions = Apollo.BaseMutationOptions<UpdateDealGoogleDriveImagesUrlMutation, UpdateDealGoogleDriveImagesUrlMutationVariables>;
export const DealPresenceDocument = gql`
    subscription DealPresence($dealId: ID!) {
  dealPresence(dealId: $dealId) {
    dealId
    users {
      userId
      username
      lastViewedAt
      lastUpdatedAt
      isInternal
      isOnline
    }
  }
}
    `;

/**
 * __useDealPresenceSubscription__
 *
 * To run a query within a React component, call `useDealPresenceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDealPresenceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealPresenceSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealPresenceSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<DealPresenceSubscription, DealPresenceSubscriptionVariables> & ({ variables: DealPresenceSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<DealPresenceSubscription, DealPresenceSubscriptionVariables>(DealPresenceDocument, options);
      }
export type DealPresenceSubscriptionHookResult = ReturnType<typeof useDealPresenceSubscription>;
export type DealPresenceSubscriptionResult = Apollo.SubscriptionResult<DealPresenceSubscription>;
export const DealPresencesDocument = gql`
    query DealPresences($dealId: ID!) {
  dealPresence(dealId: $dealId) {
    dealId
    users {
      userId
      username
      lastViewedAt
      lastUpdatedAt
      isInternal
      isOnline
    }
  }
}
    `;

/**
 * __useDealPresencesQuery__
 *
 * To run a query within a React component, call `useDealPresencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealPresencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealPresencesQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealPresencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealPresencesQuery, DealPresencesQueryVariables> & ({ variables: DealPresencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealPresencesQuery, DealPresencesQueryVariables>(DealPresencesDocument, options);
      }
export function useDealPresencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealPresencesQuery, DealPresencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealPresencesQuery, DealPresencesQueryVariables>(DealPresencesDocument, options);
        }
export function useDealPresencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DealPresencesQuery, DealPresencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DealPresencesQuery, DealPresencesQueryVariables>(DealPresencesDocument, options);
        }
export type DealPresencesQueryHookResult = ReturnType<typeof useDealPresencesQuery>;
export type DealPresencesLazyQueryHookResult = ReturnType<typeof useDealPresencesLazyQuery>;
export type DealPresencesSuspenseQueryHookResult = ReturnType<typeof useDealPresencesSuspenseQuery>;
export type DealPresencesQueryResult = Apollo.QueryResult<DealPresencesQuery, DealPresencesQueryVariables>;
export const EditPricingModeDocument = gql`
    mutation EditPricingMode($dealId: ID!, $pricingMode: PricingMode!) {
  updateDealPricingMode(dealId: $dealId, pricingMode: $pricingMode) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type EditPricingModeMutationFn = Apollo.MutationFunction<EditPricingModeMutation, EditPricingModeMutationVariables>;

/**
 * __useEditPricingModeMutation__
 *
 * To run a mutation, you first call `useEditPricingModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPricingModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPricingModeMutation, { data, loading, error }] = useEditPricingModeMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      pricingMode: // value for 'pricingMode'
 *   },
 * });
 */
export function useEditPricingModeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditPricingModeMutation, EditPricingModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditPricingModeMutation, EditPricingModeMutationVariables>(EditPricingModeDocument, options);
      }
export type EditPricingModeMutationHookResult = ReturnType<typeof useEditPricingModeMutation>;
export type EditPricingModeMutationResult = Apollo.MutationResult<EditPricingModeMutation>;
export type EditPricingModeMutationOptions = Apollo.BaseMutationOptions<EditPricingModeMutation, EditPricingModeMutationVariables>;
export const TakeDealControlDocument = gql`
    mutation TakeDealControl($dealId: ID!) {
  takeDealControl(dealId: $dealId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type TakeDealControlMutationFn = Apollo.MutationFunction<TakeDealControlMutation, TakeDealControlMutationVariables>;

/**
 * __useTakeDealControlMutation__
 *
 * To run a mutation, you first call `useTakeDealControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeDealControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeDealControlMutation, { data, loading, error }] = useTakeDealControlMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useTakeDealControlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TakeDealControlMutation, TakeDealControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TakeDealControlMutation, TakeDealControlMutationVariables>(TakeDealControlDocument, options);
      }
export type TakeDealControlMutationHookResult = ReturnType<typeof useTakeDealControlMutation>;
export type TakeDealControlMutationResult = Apollo.MutationResult<TakeDealControlMutation>;
export type TakeDealControlMutationOptions = Apollo.BaseMutationOptions<TakeDealControlMutation, TakeDealControlMutationVariables>;
export const ReleaseDealControlDocument = gql`
    mutation ReleaseDealControl($dealId: ID!) {
  releaseDealControl(dealId: $dealId) {
    ... on MutationSuccess {
      id
    }
    ... on DomainException {
      code
    }
  }
}
    `;
export type ReleaseDealControlMutationFn = Apollo.MutationFunction<ReleaseDealControlMutation, ReleaseDealControlMutationVariables>;

/**
 * __useReleaseDealControlMutation__
 *
 * To run a mutation, you first call `useReleaseDealControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseDealControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseDealControlMutation, { data, loading, error }] = useReleaseDealControlMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useReleaseDealControlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReleaseDealControlMutation, ReleaseDealControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReleaseDealControlMutation, ReleaseDealControlMutationVariables>(ReleaseDealControlDocument, options);
      }
export type ReleaseDealControlMutationHookResult = ReturnType<typeof useReleaseDealControlMutation>;
export type ReleaseDealControlMutationResult = Apollo.MutationResult<ReleaseDealControlMutation>;
export type ReleaseDealControlMutationOptions = Apollo.BaseMutationOptions<ReleaseDealControlMutation, ReleaseDealControlMutationVariables>;
export const GetBrandApiKeyDocument = gql`
    query GetBrandApiKey($brandId: ID!) {
  getBrandApiKey(brandId: $brandId)
}
    `;

/**
 * __useGetBrandApiKeyQuery__
 *
 * To run a query within a React component, call `useGetBrandApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandApiKeyQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetBrandApiKeyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables> & ({ variables: GetBrandApiKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables>(GetBrandApiKeyDocument, options);
      }
export function useGetBrandApiKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables>(GetBrandApiKeyDocument, options);
        }
export function useGetBrandApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables>(GetBrandApiKeyDocument, options);
        }
export type GetBrandApiKeyQueryHookResult = ReturnType<typeof useGetBrandApiKeyQuery>;
export type GetBrandApiKeyLazyQueryHookResult = ReturnType<typeof useGetBrandApiKeyLazyQuery>;
export type GetBrandApiKeySuspenseQueryHookResult = ReturnType<typeof useGetBrandApiKeySuspenseQuery>;
export type GetBrandApiKeyQueryResult = Apollo.QueryResult<GetBrandApiKeyQuery, GetBrandApiKeyQueryVariables>;
export const ShopifyPluginInstalledDocument = gql`
    subscription ShopifyPluginInstalled($brandId: ID!) {
  shopifyInstalled(brandId: $brandId)
}
    `;

/**
 * __useShopifyPluginInstalledSubscription__
 *
 * To run a query within a React component, call `useShopifyPluginInstalledSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShopifyPluginInstalledSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopifyPluginInstalledSubscription({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useShopifyPluginInstalledSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<ShopifyPluginInstalledSubscription, ShopifyPluginInstalledSubscriptionVariables> & ({ variables: ShopifyPluginInstalledSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<ShopifyPluginInstalledSubscription, ShopifyPluginInstalledSubscriptionVariables>(ShopifyPluginInstalledDocument, options);
      }
export type ShopifyPluginInstalledSubscriptionHookResult = ReturnType<typeof useShopifyPluginInstalledSubscription>;
export type ShopifyPluginInstalledSubscriptionResult = Apollo.SubscriptionResult<ShopifyPluginInstalledSubscription>;
export const PostRegisterDocument = gql`
    mutation PostRegister($config: PostRegisterConfig!) {
  authMutations {
    postRegister(config: $config) {
      ... on MutationSuccess {
        id
      }
      ... on DomainException {
        code
      }
    }
  }
}
    `;
export type PostRegisterMutationFn = Apollo.MutationFunction<PostRegisterMutation, PostRegisterMutationVariables>;

/**
 * __usePostRegisterMutation__
 *
 * To run a mutation, you first call `usePostRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postRegisterMutation, { data, loading, error }] = usePostRegisterMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function usePostRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PostRegisterMutation, PostRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PostRegisterMutation, PostRegisterMutationVariables>(PostRegisterDocument, options);
      }
export type PostRegisterMutationHookResult = ReturnType<typeof usePostRegisterMutation>;
export type PostRegisterMutationResult = Apollo.MutationResult<PostRegisterMutation>;
export type PostRegisterMutationOptions = Apollo.BaseMutationOptions<PostRegisterMutation, PostRegisterMutationVariables>;